{
    "401.button": "Recharger la page",
    "401.subtitle": "Tu n'es plus connecté, ta session a peut-être expiré. \n Recharge la page pour te reconnecter et reprendre où tu t'étais arrêté.",
    "401.title": "Accès refusé",
    "403.subtitle": "Ton compte Unity ne dispose pas des autorisations nécessaires pour consulter cette page. \n\n Si tu as cliqué sur un lien de catégorie, de tag ou de page d'auteur, tu peux tester ce lien dans l'aperçu de l'article. Pour mettre à jour la catégorie, le tag ou la page d'auteur ciblée, tu as besoin d'un niveau d'accès supérieur. Tu peux en faire la demande <redirectLink>via ce formulaire dans le Support Hub</redirectLink>. Sélectionne « Modification de compte » dans « Type de demande ».",
    "403.title": "Accès refusé",
    "404.button": "Retour à la page d'accueil",
    "404.subtitle": "La page que tu cherches n'existe pas.",
    "404.title": "Oups!",
    "action.copy.failure": "La copie n'est pas supportée par ton navigateur",
    "action.copy.success": "Copié avec succès !",
    "action.more": "Plus de fonctions",
    "article.action.copyForAuthorisation.disabled.tooltip": "Enregistre l'article avant de copier le texte.",
    "article.action.copyForAuthorisation.empty": "Il n'y a aucun texte de paragraphe ou d'interview à copier.",
    "article.action.copyForAuthorisation.error": "Le texte n'a pas pu être copié. Réessaie.",
    "article.action.copyForAuthorisation.success": "Texte copié dans le presse-papiers.",
    "article.replaceBreakingnews.modal.confirmButtonText": "Remplacer la breaking news",
    "article.replaceBreakingnews.modal.message": "Cet article va remplacer la breaking news \"{{ title }}\". L'article sera immédiatement publié avec les données de publication de la breaking news. Cette action ne peut pas être annulée.",
    "article.replaceBreakingnews.modal.title": "Remplacer la breaking news?",
    "article.replaceBreakingnews.toast.success": "Remplacé avec succès",
    "article.template.autocomplete.label": "Modèle",
    "article.template.empty.label": "Vide",
    "article.template.factcheck.label": "Vérification des faits",
    "article.template.interview.label": "Interview",
    "article.template.listicle.label": "Listicle",
    "article.template.opinion.label": "Opinion",
    "article.template.reach.label": "Reach",
    "article.template.reviews.label": "Critiques individuelles",
    "article.template.standard.label": "Standard",
    "articleForm.summary.modal.cancelButtonText": "Non, continuer avec l'enregistrement",
    "articleForm.summary.modal.confirmButtonText": "Oui, générer le résumé",
    "articleForm.summary.modal.message1": "Souhaites-tu générer un résumé avec l'IA avant d'enregistrer ?",
    "articleForm.summary.modal.message2": "Important: Tu dois vérifier le résumé et enregistrer à nouveau.",
    "articleForm.summary.modal.title": "L'article ne contient pas encore de résumé",
    "articles.content.external.message": "Ceci est un article externe venant de {{ externalSystem }} et est en lecture seule.",
    "articles.content.external.title": "Article {{ externalSystem }}",
    "articles.list.createButton": "Créer un article",
    "articles.setup.pageTitle": "Nouvel article",
    "articles.transformIntoTicker.button": "Convertir en Liveticker",
    "articles.transformIntoTicker.modal.confirmationMessage": "Cet article sera converti en liveticker. Tous les contenus et paramètres seront transférés. Cette action ne peut pas être annulée.",
    "articles.transformIntoTicker.modal.confirmationTitle": "Convertir en Liveticker?",
    "articles.transformIntoTicker.modal.confirmButtonText": "Convertir en Liveticker",
    "articles.transformIntoTicker.toast.success": "Article converti avec succès",
    "articles.viewEditMode.areYouSure.description": "Souhaites-tu quand même modifier l'article et ensuite fusionner les différentes versions de l'article dans la résolution des conflits ?",
    "articles.viewEditMode.areYouSure.title": "Cet article est déjà en cours de modification",
    "articles.viewEditMode.edit": "Modifier",
    "articles.viewEditMode.emptyArticle": "Cet article est vide. Basculer en mode édition pour commencer à écrire.",
    "articles.viewEditMode.inactive45minutes.description": "Tu es inactif depuis 45 minutes. Tes modifications précédentes ont déjà été enregistrées. Souhaites-tu passer en mode lecture ?",
    "articles.viewEditMode.inactive45minutes.title": "Tu modifies encore cet article ?",
    "articles.viewEditMode.keepEditing": "Continuer à modifier",
    "articles.viewEditMode.otherUserEditing": "{{ otherUser }} modifie l'article.",
    "articles.viewEditMode.otherUserProofreading.description": "En statut « Correction », seule une personne peut modifier l'article.",
    "articles.viewEditMode.otherUserProofreading.title": "Cet article est en correction",
    "articles.viewEditMode.otherUserSaved": "{{ otherUser }} a enregistré une nouvelle version de cet article. Tu dois choisir entre les éléments modifiés de la nouvelle version et ta propre version après l'enregistrement.",
    "articles.viewEditMode.otherUsersPresent": "Les utilisateurs suivants modifient déjà l'article :",
    "articles.viewEditMode.stayInEditMode": "Retour à l'article",
    "articles.viewEditMode.stayInViewMode": "Rester en mode lecture",
    "articles.viewEditMode.switchToEditMode": "Modifier l'article",
    "articles.viewEditMode.switchToViewMode": "Passer en mode lecture",
    "articles.viewEditMode.unsavedChanges.description": "Tes modifications sur l'article n'ont pas encore été sauvegardées. Tu dois les sauvegarder avant de pouvoir passer en mode lecture.",
    "articles.viewEditMode.unsavedChanges.title": "Changement de mode impossible",
    "articles.viewEditMode.userPresence.inactive": "Inactif",
    "articles.viewEditMode.userPresence.noChanges": "Aucun changement jusqu'à présent",
    "articles.viewEditMode.userPresence.saved": "Sauvegardé il y a ",
    "articles.viewEditMode.userPresence.unsavedChanges": "Modifications non sauvegardées",
    "articles.viewEditMode.view": "Lire",
    "attachmentChooser.button": "Sélectionner un document attaché",
    "attachmentChooser.noAttachment": "Aucun document attaché disponible",
    "attachmentChooser.or": "ou",
    "autocomplete.dropdown.manualOption.use": "Utiliser",
    "backend.commentRiskNotSelected": "Afficher les commentaires (risque)",
    "backend.emptyCategory": "Catégorie (au moins une)",
    "backend.emptyContentName": "Nom du contenu",
    "backend.emptyEmbedCode": "Code d'intégration",
    "backend.emptyLead": "Chapeau",
    "backend.emptyMainTenantId": "Site web principal",
    "backend.emptySeoTeaserTitleLead": "Titre/Lead du teaser SEO",
    "backend.emptySlideCredit": "Il y a des slides sans crédit",
    "backend.emptyTargetDateTime": "La date cible et le temps cible ne peuvent pas être vides.",
    "backend.emptyTeaserLead": "Chapeau du teaser",
    "backend.emptyTeaserTitle": "Titre du teaser",
    "backend.emptyTenant": "Publication (au moins une)",
    "backend.emptyTitle": "Titre",
    "backend.emptyUrl": "Url",
    "backend.invalidTargetDateTime": "Date cible et créneau horaire valides",
    "backend.invalidTargetTextLength": "Le texte est plus court ou plus long que convenue. Le changement d'état n'est possible que si la longueur cible (+/- 150 caractères) est respectée.",
    "backend.mainCategoryNotSyncedWithDesknet": "La catégorie principale n'est pas synchronisée avec Kordiam. Sélectionne-en une qui est synchronisée avec Kordiam.",
    "backend.noMainCategory": "Catégorie principale",
    "backend.noSeoCheckDone": "Utiliser le SEO Helper",
    "backend.noSpellCheckDone": "Utiliser le correcteur d'orthographe",
    "backend.notSupportedTenantPresent": "Cette fonction n’est pas disponible pour au moins un des websites / apps sélectionnés.",
    "backend.noUserNeed": "Commencer l'analyse des User Needs",
    "backend.onlyOneSeriesAllowed": "Sélectionner au max. une catégorie de type Série",
    "backend.unpublishedRelatedContent": "Contenu en relation: Dans les contenus en relation, les elements suivants ne sont pas publiés et doivent être supprimés ou mise en statut 'Publié': <strong>{{details}}</strong>",
    "backend.wrongArticleProofreadStatus": "Le status de l'article doit être configuré sur 'A_Korrektur/A_Correction'",
    "backend.wrongArticlePublicationStatus": "Le status de l'article doit être configuré sur 'A_Fertig/A_Pret'",
    "backend.wrongNumberOfRelatedContent": "Contenu en relation (au moins trois)",
    "breakingnews.detail.title": "Contenu de la breaking news",
    "breakingnews.form.body": "Body",
    "breakingnews.form.lead": "Chapeau",
    "breakingnews.form.title": "Titre",
    "breakingnews.form.titleHeader": "Surtitre",
    "breakingnews.list.createButton": "Créer une breaking news",
    "breakingnews.relatedcontent.modalTitle": "Sélectionner la breaking news à remplacer",
    "breakingnews.relatedcontent.submitButtonText": "Sélectionner",
    "breakingnews.setup.pageTitle": "Nouvelle breaking news",
    "breakingnews.setupForm.modal.confirmationMessage": "Le texte suivant sera envoyé en tant que message push et utilisé comme titre de la breaking news:",
    "breakingnews.setupForm.modal.confirmationTitle": "Envoyer le message push et publier le contenu?",
    "breakingnews.setupForm.modal.confirmButtonText": "Envoyer et publier",
    "breakingnews.setupForm.pushCategories": "Catégories push",
    "breakingnews.setupForm.pushMessage": "Message push",
    "breakingnews.setupForm.submitButton": "Envoyer et publier",
    "breakingnews.setupForm.title": "Configuration et message push",
    "breakingnews.transformIntoTicker.button": "Convertir en Liveticker",
    "breakingnews.transformIntoTicker.message": "Activer l'écriture d'entrées liveticker en transformant cette breaking news en liveticker",
    "breakingnews.transformIntoTicker.modal.confirmationMessage": "Le contenu de cette breaking news sera transformé en contenu liveticker. Tous les textes et paramètres seront repris, y compris le label de la breaking news. Cette action ne peut pas être annulée.",
    "breakingnews.transformIntoTicker.modal.confirmationTitle": "Convertir en Liveticker?",
    "breakingnews.transformIntoTicker.modal.confirmButtonText": "Convertir en Liveticker",
    "breakingnews.transformIntoTicker.title": "Evénements Liveticker",
    "breakingnews.transformIntoTicker.toast.success": "Remplacé avec succès",
    "browserSupportWarning": "Tu utilises une version très ancienne de ton navigateur web. Cela peut entraîner des problèmes lors de l'utilisation de Unity CMS et compromettre votre sécurité en ligne. Suis <instructionsLink>ces instructions</instructionsLink> pour mettre à jour ton navigateur.",
    "category.edit.title": "Modifier la catégorie",
    "category.form.active": "Active",
    "category.form.activeInfo": "Les catégories inactives ne seront plus disponibles lors de la sélection de catégories dans Unity. Ils ne seront pas supprimés s'ils ont déjà été sélectionnés.",
    "category.form.asyncvalidate.reject": "Ce nom est déjà utilisé",
    "category.form.confirmInactivationOfParent": "Désactiver cette catégorie va également désactiver toutes ses sous-catégories. Es-tu sûr de vouloir sauvegarder ?",
    "category.form.expiryDate": "Actif jusqu'à la fin de",
    "category.form.modal.confirm": "Confirmer",
    "category.form.name": "Nom",
    "category.form.notFoundContent": "Catégorie introuvable",
    "category.form.parentCategory": "Catégorie parent",
    "category.form.syncWithDesknet": "Synchroniser la catégorie avec Kordiam",
    "category.form.type": "Type",
    "category.form.type.default": "Default",
    "category.form.type.series": "Série",
    "category.list.createButton": "Créer une catégorie",
    "category.list.item.expiryDatePrefix": "jusqu'au {{date}}",
    "category.list.tab.active": "Actif",
    "category.list.tab.all": "Tout",
    "category.list.tab.syncedWithDesknet": "Synchronisé avec Kordiam",
    "category.name": "Nom",
    "category.parentName": "Catégorie parent",
    "category.setup.title": "Créer une catégorie",
    "category.type": "Type",
    "collections.all": "Tout",
    "collections.categoryIds": "Attribuer à ces catégories lors de l'importation",
    "collections.edit.title": "Modifier le mot-clé",
    "collections.hasCategories": "A des catégories attribuées",
    "collections.header.title": "Collection",
    "collections.keyword": "Mot-clé BrixWire",
    "collections.noCategories": "Aucune catégorie",
    "compare.alreadyInConflictNotification": "Oups, on dirait que quelqu'un a enregistré une autre version pendant que tu travailliais sur cette modification!",
    "compare.isInConflictNotification": "Il y a des modifications par un autre utilisateur. Elles doivent être revues avant d'être enregistrées",
    "compare.itemDeleted": "Élément supprimé",
    "compare.itemNonExisting": "Dans cette version, ce contenu n'existe pas",
    "compare.revision.itemDeleted": "L'élément a été ajouté dans une révision ultérieure",
    "compare.revision.itemNonExisting": "Dans cette révision ce contenu n'existe pas",
    "conflict.headers.changes": "Modifications",
    "conflict.headers.changes.description": "Choisir l'élément à conserver en cochant la case",
    "conflict.headers.changes.lastRevision": "dernière révision",
    "conflict.headers.changes.yourVersion": "votre version",
    "conflict.headers.result": "Ceci sera enregistré comme nouvelle révision",
    "conflict.headers.subtitle": "Décide quelles modifications doivent être sauvegardées et lesquelles doivent être ignorées. Pour ce faire, coche les cases à gauche, puis clique sur enregistrer.",
    "conflict.headers.subtitle.tooltip": "Question : Pourquoi cet écran s'affiche-t-il ? Réponse : Pendant que tu travailles sur le contenu, quelqu'un d'autre a également modifié et enregistré des modifications. Tu dois donc décider lesquelles de tes modifications doivent être sauvegardées. Question : Que dois-je faire maintenant ? Réponse : Sur le côté gauche, les différences sont montrées. La case à côté de l'élément permet de choisir lequel des éléments doit apparaître dans la nouvelle révision. L'enregistrement n'est possible que lorsque la décision a été prise pour tous les éléments.",
    "conflict.headers.title": "Quelqu'un d'autre a enregistré ce contenu pendant que vous le modifiiez. Certaines modifications sont contradictoires.",
    "conflict.result.chooseMessage": "Choisissez un élément à gauche",
    "conflict.saveButton.tooltip": "Toutes les décisions n'ont pas été prises. Sélectionnez une version pour chaque élément à gauche.",
    "content.setup.mainCategory": "Catégorie principale",
    "content.setup.tenants": "Publications",
    "contentitem.bookmarkButton": "Mettre dans mes favoris",
    "contentitem.datePrefix.default": "Mis à jour",
    "contentitem.deleteButton": "Supprimer",
    "contentItem.deletedArticle": "Cet article a été supprimé. Il n'est plus disponible et ne sera pas republié.",
    "contentitem.editButton": "Modifier",
    "contentitem.fullDatePrefix.default": "à",
    "contentItem.placeholder": "espace réservé",
    "contentItem.placeholder.emptyText": "Actuellement aucun contenu disponible",
    "contentitem.placementHistoryButton": "Historique des placements",
    "contentitem.previewButton": "Aperçu",
    "contentitem.publishButton": "publier",
    "contentitem.publishedTimeago": "Publié dans cette catégorie sur :",
    "contentLocaleRadioGroup": "Afficher le contenu de:",
    "contentLocaleRadioGroup.de-CH": "Suisse alémanique ",
    "contentLocaleRadioGroup.description": "Tu ne verras que les contenus (articles, tickers etc.) et titres de ce langage.",
    "contentLocaleRadioGroup.fr-CH": "Suisse romande",
    "contentSelection.buttonLabel": "Sélectionner un contenu",
    "contentSelection.column.createdAt": "Créé",
    "contentSelection.column.creator": "Auteur",
    "contentSelection.column.edit": "Modifier",
    "contentSelection.column.tenants": "Publications",
    "contentSelection.column.title": "Titre",
    "contentSelection.column.updatedAt": "Modifié",
    "contentSelection.contentItem.published": "Publié",
    "contentSelection.modal.submitButton": "Ajouter",
    "contentSelection.modal.title": "Sélectionner un contenu",
    "contentStation.header.actions.replaceBreakingnews": "Remplacer la breaking news",
    "contentStation.header.actions.replaceBreakingnews.disabled.tooltip": "L'article doit être \"Prêt à publier\"",
    "contentStation.header.actions.transformArticleIntoTicker.disabled.tooltip": "Tes modifications sur l'article n'ont pas encore été sauvegardées. Tu dois les sauvegarder avant de pouvoir convertir l'article en liveticker.",
    "contentStatus": "Statut du contenu",
    "contentStatus.draft": "Brouillon",
    "contentStatus.proofread": "Correction",
    "contentStatus.readyToPublish": "Prêt",
    "contentStatus.requiredRework": "Révision",
    "contentStatus.review1": "Relecture",
    "contentStatus.review2": "Edition",
    "contentStatus.seo": "SEO",
    "contentType.articles": "Article",
    "contentType.breakingnews": "Breaking news",
    "contentType.embeds": "Contenu intégré",
    "contentType.links": "Liens externes",
    "contentType.slideshows": "Diaporama",
    "contentType.tickers": "Liveticker",
    "contentType.videos": "Vidéo",
    "curatedList.abTests.filter.statuses": "Statut",
    "curatedList.description": "Sélectionne un onglet ci-dessous pour afficher la liste adaptée à ton cas d'utilisation spécifique. Toutes les listes s'actualisent automatiquement.",
    "curatedList.tab.abTests": "Tests A/B",
    "curatedList.tab.proofreading": "Correction",
    "dataGrid.columns": "Sélectionner les colonnes",
    "dataGrid.density": "Densité des lignes",
    "dataGrid.density.comfortable": "Confortable",
    "dataGrid.density.compact": "Compacte",
    "dataGrid.density.standard": "Standard",
    "dataGrid.resetLayout": "Réinitialiser la disposition",
    "editor.edit.embed.slideshow": "Modifier le diaporama",
    "editor.embeddedcontent.placeholder.addButton": "Ajouter",
    "editor.embeddedcontent.tooltip": "Certains contenus peuvent ne pas être rendus ici pour des raisons de sécurité. Le bouton \"Afficher l'aperçu\" en haut à droite affiche le contenu tel qu'il sera publié.",
    "editor.embedWrapperProgress.generateImageAltText": "Génération du texte alternatif...",
    "editor.embedWrapperProgress.generateThumbnail": "Génération de l'image d'aperçu...",
    "editor.embedWrapperProgress.uploadFile": "Téléchargement...",
    "editor.headings.tooltip": "Le surtitre ne doit pas comporter plus de 30 caractères, le titre pas plus de 70 et le chapeau pas plus de 140. Le chapeau est idéalement composé de deux phrases.",
    "editor.insert.embed.basicBlocks.crossheadDefault": "Intertitre",
    "editor.insert.embed.basicBlocks.crossheadOrderedListicle": "Listicle numéroté",
    "editor.insert.embed.basicBlocks.crossheadSubsection": "Sous-chapitre",
    "editor.insert.embed.basicBlocks.crossheadUnorderedListicle": "Listicle non numéroté",
    "editor.insert.embed.basicBlocks.p": "Paragraphe",
    "editor.insert.embed.bluesky": "Ajouter un code embarqué Bluesky",
    "editor.insert.embed.customJson": "Ajouter un Custom JSON",
    "editor.insert.embed.dynamicTeaser": "Ajouter un teaser dynamique",
    "editor.insert.embed.embeddedContent": "Ajouter un contenu",
    "editor.insert.embed.embeddedSnippet": "Composant",
    "editor.insert.embed.facebook": "Ajouter un code embarqué Facebook",
    "editor.insert.embed.frontendComponent": "Ajouter un Interactif",
    "editor.insert.embed.image": "Ajouter une image",
    "editor.insert.embed.importInterview": "Import Interview",
    "editor.insert.embed.infobox": "Ajouter une infobox",
    "editor.insert.embed.instagram": "Ajouter un code embarqué Instagram",
    "editor.insert.embed.interviewSegment": "Interview",
    "editor.insert.embed.poll": "Ajouter un sondage",
    "editor.insert.embed.quote": "Insérer une citation",
    "editor.insert.embed.ratingPoll": "Ajouter une note",
    "editor.insert.embed.separator": "Insérer une ligne horizontale",
    "editor.insert.embed.slideshow": "Insérer un diaporama",
    "editor.insert.embed.summary": "Résumé",
    "editor.insert.embed.threads": "Ajouter un code embarqué Threads",
    "editor.insert.embed.tickerSummary": "Résumé",
    "editor.insert.embed.tiktok": "Ajouter un code embarqué TikTok",
    "editor.insert.embed.twitter": "Ajouter un code embarqué X",
    "editor.insert.embed.videoCms": "Ajouter un code embarqué VideoCMS",
    "editor.insert.embed.youtube": "Ajouter un code embarqué YouTube",
    "editor.insert.embed.zattoo": "Ajouter un code embarqué Zattoo",
    "editor.insertToolbar.label.bluesky": "Bluesky",
    "editor.insertToolbar.label.crossheadDefault": "Intertitre",
    "editor.insertToolbar.label.crossheadOrderedListicle": "Listicle numéroté",
    "editor.insertToolbar.label.crossheadSubsection": "Sous-chapitre",
    "editor.insertToolbar.label.crossheadUnorderedListicle": "Listicle non numéroté",
    "editor.insertToolbar.label.customJson": "Custom JSON",
    "editor.insertToolbar.label.dynamicTeaser": "Teaser dynamique",
    "editor.insertToolbar.label.embeddedContent": "Contenu",
    "editor.insertToolbar.label.embeddedSnippet": "Composants",
    "editor.insertToolbar.label.facebook": "Facebook",
    "editor.insertToolbar.label.footer": "Pied de page",
    "editor.insertToolbar.label.frontendComponent": "Interactif",
    "editor.insertToolbar.label.img": "Image",
    "editor.insertToolbar.label.importInterview": "Import Interview",
    "editor.insertToolbar.label.infobox": "Infobox",
    "editor.insertToolbar.label.instagram": "Instagram",
    "editor.insertToolbar.label.interviewSegment": "Interview",
    "editor.insertToolbar.label.p": "Paragraphe",
    "editor.insertToolbar.label.poll": "Sondage",
    "editor.insertToolbar.label.quote": "Citation",
    "editor.insertToolbar.label.ratingPoll": "Note",
    "editor.insertToolbar.label.separator": "Séparateur",
    "editor.insertToolbar.label.slideshow": "Diaporama",
    "editor.insertToolbar.label.summary": "Résumé - points",
    "editor.insertToolbar.label.threads": "Threads",
    "editor.insertToolbar.label.tickerSummary": "Résumé - texte",
    "editor.insertToolbar.label.tiktok": "TikTok",
    "editor.insertToolbar.label.twitter": "X",
    "editor.insertToolbar.label.videoCms": "Video CMS",
    "editor.insertToolbar.label.youtube": "YouTube",
    "editor.insertToolbar.label.zattoo": "Zattoo",
    "editor.insertToolbar.summary.tooltip": "Un seul résumé par contenu peut être ajouté.",
    "editor.insertToolbar.tab.content": "Contenu",
    "editor.insertToolbar.tab.embeds": "Intégrations",
    "editor.plugin.a.authorLink.title": "Auteur",
    "editor.plugin.a.categoryLink.title": "Catégorie",
    "editor.plugin.a.externalLink.title": "Lien externe",
    "editor.plugin.a.insert": "Ajouter un lien",
    "editor.plugin.a.internalLink.title": "Contenu",
    "editor.plugin.a.linkDetails.editButton": "Modifier",
    "editor.plugin.a.linkDetails.removeButton": "Supprimer le lien",
    "editor.plugin.a.modal.form.externalLink": "Lien externe",
    "editor.plugin.a.modal.form.internalLink": "Lien interne",
    "editor.plugin.a.modal.form.reference.label": "Référence",
    "editor.plugin.a.modal.form.url.placeholder": "Copiez ou tappez un lien",
    "editor.plugin.a.modal.title": "Ajouter un lien",
    "editor.plugin.a.remove": "Supprimer le lien",
    "editor.plugin.a.selectTarget.button": "Sélectionner la cible",
    "editor.plugin.a.selectTargetModal.authorLink.label": "Auteur",
    "editor.plugin.a.selectTargetModal.categoryLink.label": "Catégorie",
    "editor.plugin.a.selectTargetModal.internalLink.label": "Contenu",
    "editor.plugin.a.selectTargetModal.submitButton": "Ajouter",
    "editor.plugin.a.selectTargetModal.tagLink.label": "Tag",
    "editor.plugin.a.selectTargetModal.title": "Sélectionner la cible",
    "editor.plugin.a.tagLink.title": "Tag",
    "editor.plugin.articleBuddy.approve": "Appliquer",
    "editor.plugin.articleBuddy.category.balancedReporting.description": "Identifie les omissions ou distorsions sélectives qui faussent l'ensemble du tableau.",
    "editor.plugin.articleBuddy.category.balancedReporting.label": "Équilibre éditorial",
    "editor.plugin.articleBuddy.category.chartPotential.description": "Repère les passages qu’un graphique Datawrapper ou carte rendrait plus clairs. Pour ce faire, l’outil analyse l’article pour en extraire les données exploitables et les prépare de façon à ce que tu puisses les charger directement dans le Datawrapper Helper. Il complète les données manquantes à partir de sources publiques fiables, avec citation.",
    "editor.plugin.articleBuddy.category.chartPotential.label": "Potentiel graphique",
    "editor.plugin.articleBuddy.category.clarity.description": "Signale le jargon non expliqué, les abréviations ou le contexte manquant. Garantit l'accessibilité pour un large public.",
    "editor.plugin.articleBuddy.category.clarity.label": "Clarté",
    "editor.plugin.articleBuddy.category.contextAndAccuracy.description": "Évalue si les affirmations sont étayées par des sources et fournissent suffisamment de contexte pour la compréhension.",
    "editor.plugin.articleBuddy.category.contextAndAccuracy.label": "Contexte et précision",
    "editor.plugin.articleBuddy.category.erase.description": "Signale des passages entiers pouvant être supprimés pour raccourcir le texte sans perdre le sens essentiel.",
    "editor.plugin.articleBuddy.category.erase.label": "Supprimer",
    "editor.plugin.articleBuddy.category.fairness.description": "Vérifie que les parties concernées ont eu droit de réponse et que la présomption d'innocence est respectée.",
    "editor.plugin.articleBuddy.category.fairness.label": "Équité",
    "editor.plugin.articleBuddy.category.genderInclusiveLanguage.description": "Vérifie l'utilisation du masculin générique. Recommande des alternatives neutres tout en respectant les personnes nommément citées.",
    "editor.plugin.articleBuddy.category.genderInclusiveLanguage.label": "Écriture inclusive",
    "editor.plugin.articleBuddy.category.helvetisms.description": "Assure l'utilisation cohérente du français standard suisse. Remplace les gallicismes par les helvétismes appropriés.",
    "editor.plugin.articleBuddy.category.helvetisms.label": "Français de Suisse",
    "editor.plugin.articleBuddy.category.independence.description": "Évalue si le reportage est indépendant des influences des relations publiques.",
    "editor.plugin.articleBuddy.category.independence.label": "Indépendance",
    "editor.plugin.articleBuddy.category.languageStyle.description": "Vérifie les nominalisations, les constructions passives, les mots de remplissage, les clichés et les redondances. Privilégie les formulations actives et concises avec des verbes forts.",
    "editor.plugin.articleBuddy.category.languageStyle.label": "Langue & Style",
    "editor.plugin.articleBuddy.category.misspelledNames.description": "Relève les noms des personnes qui semblent mal orthographiés. Indique à la place l'orthographe qui semble être la bonne. Pour ce faire, l'outil compare chaque nom via une recherche web avec des sources fiables (ex. sites institutionnels ou Linkedin) en tenant compte du contexte de l'article.",
    "editor.plugin.articleBuddy.category.misspelledNames.label": "Noms mal orthographiés",
    "editor.plugin.articleBuddy.category.nonDiscrimination.description": "Vérifie que la nationalité, l'ethnicité, la religion ou l'orientation sexuelle ne sont mentionnées que si elles sont pertinentes pour l'histoire.",
    "editor.plugin.articleBuddy.category.nonDiscrimination.label": "Non-discrimination",
    "editor.plugin.articleBuddy.category.opinionVsFact.description": "Vérifie que les opinions sont clairement marquées comme telles et non présentées comme des faits.",
    "editor.plugin.articleBuddy.category.opinionVsFact.label": "Opinion vs fait",
    "editor.plugin.articleBuddy.category.paraphrase.description": "Propose des formulations plus courtes qui conservent le sens tout en réduisant le nombre de caractères.",
    "editor.plugin.articleBuddy.category.paraphrase.label": "Reformuler",
    "editor.plugin.articleBuddy.category.pluralism.description": "Évalue si différentes perspectives sont représentées, notamment sur les sujets controversés.",
    "editor.plugin.articleBuddy.category.pluralism.label": "Pluralisme",
    "editor.plugin.articleBuddy.category.privacy.description": "Évalue le traitement des informations sensibles et des détails privés.",
    "editor.plugin.articleBuddy.category.privacy.label": "Vie privée",
    "editor.plugin.articleBuddy.category.punctuation.description": "Vérifie l'utilisation correcte des deux-points, tirets et autres signes de ponctuation. Signale les usages excessifs ou incorrects.",
    "editor.plugin.articleBuddy.category.punctuation.label": "Ponctuation",
    "editor.plugin.articleBuddy.category.quotations.description": "Évalue si les citations apportent une valeur ajoutée (opinion, émotion, originalité). Signale les citations vides ou redondantes qui devraient être paraphrasées ou supprimées.",
    "editor.plugin.articleBuddy.category.quotations.label": "Citations",
    "editor.plugin.articleBuddy.category.sentenceStructure.description": "Identifie les phrases trop longues ou imbriquées. Recommande de les diviser en unités claires et lisibles.",
    "editor.plugin.articleBuddy.category.sentenceStructure.label": "Construction des phrases",
    "editor.plugin.articleBuddy.category.sourceTransparency.description": "Vérifie que les sources sont rendues transparentes et que les conflits d'intérêts potentiels sont divulgués.",
    "editor.plugin.articleBuddy.category.sourceTransparency.label": "Transparence des sources",
    "editor.plugin.articleBuddy.category.structureNarrativeArc.description": "Évalue l'accroche, la logique du texte, les transitions et la conclusion. Signale l'absence de fil conducteur ou les débuts/fins faibles.",
    "editor.plugin.articleBuddy.category.structureNarrativeArc.label": "Structure & Dramaturgie",
    "editor.plugin.articleBuddy.category.toneLanguageRegister.description": "Vérifie les familiarismes inappropriés, le langage administratif ou les formulations partisanes. Assure un ton neutre et professionnel.",
    "editor.plugin.articleBuddy.category.toneLanguageRegister.label": "Registre de langue",
    "editor.plugin.articleBuddy.copyReason": "Copier les détails de la suggestion",
    "editor.plugin.articleBuddy.dismiss": "Ignorer",
    "editor.plugin.articleBuddy.empty": "Supprimer le texte",
    "editor.plugin.basicBlocks.apply": "Style de texte",
    "editor.plugin.basicBlocks.crossheadDefault": "Intertitre",
    "editor.plugin.basicBlocks.crossheadDefault.apply": "Intertitre",
    "editor.plugin.basicBlocks.crossheadOrderedListicle": "Listicle numéroté",
    "editor.plugin.basicBlocks.crossheadOrderedListicle.apply": "Listicle numéroté",
    "editor.plugin.basicBlocks.crossheadSubsection": "Sous-chapitre",
    "editor.plugin.basicBlocks.crossheadSubsection.apply": "Sous-chapitre",
    "editor.plugin.basicBlocks.crossheadUnorderedListicle": "Listicle non numéroté",
    "editor.plugin.basicBlocks.crossheadUnorderedListicle.apply": "Listicle non numéroté",
    "editor.plugin.basicBlocks.footer": "Pied de page",
    "editor.plugin.basicBlocks.footer.apply": "Pied de page",
    "editor.plugin.basicBlocks.lead.placeholderText": "Lead",
    "editor.plugin.basicBlocks.p.apply": "Paragraphe",
    "editor.plugin.basicBlocks.title.placeholderText": "Titre",
    "editor.plugin.basicBlocks.titleHeader.placeholderText": "Surtitre",
    "editor.plugin.blockToolbar.delete": "Supprimer",
    "editor.plugin.blockToolbar.edit": "Modifier",
    "editor.plugin.blockToolbar.rephrase": "Reformule le texte du paragraphe avec l'IA pour améliorer sa clarté et sa lisibilité.",
    "editor.plugin.blockToolbar.rephrase.disabledTooltip": "Un texte de paragraphe vide ne peut pas être reformulé.",
    "editor.plugin.bluesky.modal.edit": "Modifier le post Bluesky",
    "editor.plugin.bluesky.modal.insert": "Insérer un post Bluesky",
    "editor.plugin.bluesky.modal.submitButton": "Appliquer",
    "editor.plugin.bluesky.title": "Bluesky",
    "editor.plugin.bold.apply": "Gras",
    "editor.plugin.comment.form.placeholder": "Créer un commentaire...",
    "editor.plugin.comment.insert": "Créer un commentaire",
    "editor.plugin.comment.notAvailable": "Ce commentaire n'est plus disponible.",
    "editor.plugin.comment.reply.form.placeholder": "Répondre...",
    "editor.plugin.comment.resolve": "Résoudre le commentaire",
    "editor.plugin.csSlideshow.modal.edit": "Modifier le diaporama",
    "editor.plugin.csSlideshow.modal.insert": "Insérer un diaporama",
    "editor.plugin.csSlideshow.title": "Diaporama",
    "editor.plugin.customJson.message": "Unity ne charge pas cet élément. Il peut être visualisé dans la prévisualisation.",
    "editor.plugin.customJson.modal.edit": "Modifier le Custom JSON",
    "editor.plugin.customJson.modal.insert": "Ajouter un Custom JSON",
    "editor.plugin.customJson.modal.submitButton": "Appliquer",
    "editor.plugin.customJson.title": "Custom JSON",
    "editor.plugin.dynamicTeaser.form.addContents": "Ajouter des contenus",
    "editor.plugin.dynamicTeaser.form.image": "Image",
    "editor.plugin.dynamicTeaser.form.submitButton": "Appliquer",
    "editor.plugin.dynamicTeaser.modal.edit": "Modifier le teaser dynamique",
    "editor.plugin.dynamicTeaser.title": "Teaser dynamique",
    "editor.plugin.dynamicTeaser.title.placeholder": "Titre",
    "editor.plugin.dynamicTeaser.tooltip": "Le dynamic teaser a toujours un titre, il doit être spécifique et non pas «Sur le même thème». Les articles doivent offrir une valeur ajoutée aux lecteurs et lectrices dans cette situation. N'ajoute pas plus de trois articles, sauf dans des cas exceptionnels. <spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1GDCAagqNSMa6gtLSEfq8rLIQB9EnwGI5ZSGUJ9pGrGs/edit?usp=sharing'>Le teaser dynamique.</linkComponent>",
    "editor.plugin.embed.noPlaceholder": "Aucun placeholder trouvé pour {{type}}",
    "editor.plugin.embeddedContent.modal.edit": "Contenu intégré",
    "editor.plugin.embeddedContent.modal.submitButton": "Appliquer",
    "editor.plugin.embeddedContent.title": "Contenu intégré",
    "editor.plugin.embeddedContent.tooltip": "Certains contenus peuvent ne pas être rendus ici pour des raisons de sécurité. Le bouton \"Afficher l'aperçu\" en haut à droite affiche le contenu tel qu'il sera publié.",
    "editor.plugin.embeddedSnippet.modal.edit": "Advanced",
    "editor.plugin.embeddedSnippet.modal.insert": "Composants",
    "editor.plugin.embeddedSnippet.title": "Extrait",
    "editor.plugin.enDash.insert": "En dash",
    "editor.plugin.facebook.modal.edit": "Modifier le post Facebook",
    "editor.plugin.facebook.modal.insert": "Insérer un post Facebook",
    "editor.plugin.facebook.modal.submitButton": "Appliquer",
    "editor.plugin.facebook.title": "Facebook",
    "editor.plugin.frontendComponent.form.addButton": "Ajouter une propriété",
    "editor.plugin.frontendComponent.form.removeButton": "Supprimer une propriété",
    "editor.plugin.frontendComponent.key": "Clé",
    "editor.plugin.frontendComponent.logoAlt": "Logo Interactif",
    "editor.plugin.frontendComponent.message": "Unity ne charge pas cet élément. Il peut être visualisé dans la prévisualisation.",
    "editor.plugin.frontendComponent.modal.edit": "Modifier l'Interactif",
    "editor.plugin.frontendComponent.modal.insert": "Ajouter un Interactif",
    "editor.plugin.frontendComponent.modal.submitButton": "Appliquer",
    "editor.plugin.frontendComponent.title": "Interactif",
    "editor.plugin.frontendComponent.value": "Valeur",
    "editor.plugin.guillemets.insert": "Guillemets",
    "editor.plugin.img.form.image": "Découper & point focal",
    "editor.plugin.img.imageDescription.label": "Alt text",
    "editor.plugin.img.imageDescription.tooltip": "Le texte alternatif est généré par défaut par l'IA. Pour le mettre à jour, clique sur le bouton en forme de crayon à gauche de l'image.",
    "editor.plugin.img.modal.edit": "Modifier l'image",
    "editor.plugin.img.modal.insert": "Ajouter une image",
    "editor.plugin.img.modal.submitButton": "Ajouter",
    "editor.plugin.img.modal.submitButton.editMode": "Appliquer",
    "editor.plugin.img.title": "Image",
    "editor.plugin.img.tooltip": "Chaque image a besoin d'une légende et d'un crédit. La légende doit contenir les informations les plus importantes sur l'image pour le référencement (qui figure sur l'image? Où et quand a-t-elle été prise ? etc.).",
    "editor.plugin.importInterview.errors": "Certains éléments d'interview sont invalides. Ils seront importés en tant que paragraphes.",
    "editor.plugin.importInterview.modal.insert": "Importer une interview",
    "editor.plugin.importInterview.parsedText": "Texte converti",
    "editor.plugin.importInterview.sourceText": "Text copié",
    "editor.plugin.importInterview.submitButton": "Convertir",
    "editor.plugin.infobox.form.collapsed": "Réduit",
    "editor.plugin.infobox.form.content": "Contenu",
    "editor.plugin.infobox.form.title": "Titre",
    "editor.plugin.infobox.frame.title": "Infobox",
    "editor.plugin.infobox.modal.edit": "Modifier l'Infobox",
    "editor.plugin.infobox.modal.submitButton": "Appliquer",
    "editor.plugin.infobox.title": "Infobox",
    "editor.plugin.infobox.tooltip": "L'encadré doit avoir un titre, qui doit être aussi descriptif et concret que possible. Les points servant à énumérer des informations et les images sont possibles à l'intérieur des encadrés, mais tous les autres éléments ne sont pas affichés.",
    "editor.plugin.instagram.modal.edit": "Modifier le post Instagram",
    "editor.plugin.instagram.modal.insert": "Insérer un post Instagram",
    "editor.plugin.instagram.modal.submitButton": "Appliquer",
    "editor.plugin.instagram.title": "Instagram",
    "editor.plugin.interviewSegment.answer.placeholder": "Réponse",
    "editor.plugin.interviewSegment.question.placeholder": "Question",
    "editor.plugin.interviewSegment.title": "Interview",
    "editor.plugin.italic.apply": "Italique",
    "editor.plugin.ol.insert": "Liste numérotée",
    "editor.plugin.poll.answer.placeholder": "Réponse",
    "editor.plugin.poll.question.placeholder": "Question",
    "editor.plugin.poll.title": "Sondage",
    "editor.plugin.quote.caption.placeholder": "Auteur",
    "editor.plugin.quote.text.placeholder": "Texte citation",
    "editor.plugin.quote.title": "Citation",
    "editor.plugin.quote.tooltip": "Une citation a une longueur maximale de 85 caractères. Les « et » ne sont pas mis automatiquement. S'il s'agit d'une citation directe, remplis le champ de l’auteur en insérant [nom, rôle].",
    "editor.plugin.ratingPoll.form.image": "Image",
    "editor.plugin.ratingPoll.form.name": "Nom",
    "editor.plugin.ratingPoll.form.text": "Texte",
    "editor.plugin.ratingPoll.modal.edit": "Modifier la note",
    "editor.plugin.ratingPoll.modal.insert": "Ajouter une note",
    "editor.plugin.ratingPoll.modal.submitButton": "Ajouter",
    "editor.plugin.ratingPoll.modal.submitButton.editMode": "Appliquer",
    "editor.plugin.rephrase.accept": "Appliquer la reformulation",
    "editor.plugin.rephrase.diff": "Afficher/masquer les modifications",
    "editor.plugin.rephrase.none": "Aucune",
    "editor.plugin.rephrase.reason": "Explication",
    "editor.plugin.rephrase.reject": "Ignorer la reformulation",
    "editor.plugin.rephrase.showLess": "Voir moins",
    "editor.plugin.rephrase.showMore": "Voir plus",
    "editor.plugin.singleGuillemets.insert": "Guillemets simples",
    "editor.plugin.slideshow.disabled": "Ce diaporama a été mis en non-publié et ne sera pas affiché.",
    "editor.plugin.slideshow.disabled.link": "Modifier le diaporama",
    "editor.plugin.slideshow.disabled.withcontentname": "Le diaporama {{slideshowName}} a été mis en non-publié et ne sera pas affiché.",
    "editor.plugin.slideshow.empty.link": "Modifier le diaporama",
    "editor.plugin.slideshow.empty.message": "Il n'y a pas de slide dans ce diaporama.",
    "editor.plugin.slideshow.form.author": "Auteur",
    "editor.plugin.slideshow.form.image": "Image à la une",
    "editor.plugin.slideshow.form.submitButton": "Appliquer",
    "editor.plugin.slideshow.form.title": "Titre",
    "editor.plugin.slideshow.form.updated": "Modifié",
    "editor.plugin.slideshow.modal.edit": "Modifier le diaporama",
    "editor.plugin.slideshow.modal.insert": "Insérer un diaporama",
    "editor.plugin.slideshow.navigation.next": "Suivant",
    "editor.plugin.slideshow.navigation.previous": "Précédent",
    "editor.plugin.slideshow.title": "Diaporama",
    "editor.plugin.socialEmbed.securityMessage1": "Unity ne charge pas les posts {{socialNetworkName}} pour des raisons de sécurité.",
    "editor.plugin.socialEmbed.securityMessage2": "Si tu veux vérifier que tu as ajouté le bon post,  clique sur ce lien.",
    "editor.plugin.socialEmbed.securityMessage3": "Clique sur le bouton « Aperçu » <PreviewIcon /> dans la barre d'outils en haut à droite pour voir comment le contenu sera affiché sur le site web.",
    "editor.plugin.softHyphen.insert": "Trait d’union conditionnel",
    "editor.plugin.specialCharacters.insert": "Symboles",
    "editor.plugin.spellChecker.advice": "Recommandation",
    "editor.plugin.spellChecker.ignore": "Ignorer",
    "editor.plugin.spellChecker.noAdvice": "Aucune recommandation disponible.",
    "editor.plugin.spellChecker.noProposals": "Aucune suggestion pour cette erreur",
    "editor.plugin.spellChecker.showLess": "Voir moins",
    "editor.plugin.spellChecker.showMore": "Voir plus",
    "editor.plugin.spellChecker.suggestForDictionary": "Proposer pour le dictionnaire",
    "editor.plugin.spellChecker.suggestionSubmitted": "Merci. La proposition sera examinée par l'administrateur du dictionnaire.",
    "editor.plugin.spellChecker.useProposal": "Clique pour remplacer dans l'éditeur",
    "editor.plugin.subscript.apply": "Indice",
    "editor.plugin.subscript2.insert": "Indice 2",
    "editor.plugin.summary.button.generate": "Générer une suggestion",
    "editor.plugin.summary.button.generate.tooplip": "La suggestion ne peut pas être générée pour un article vide.",
    "editor.plugin.summary.button.replace": "Remplacer par nouvelle suggestion",
    "editor.plugin.summary.error": "Une erreur s'est produite lors de la génération du résumé.\nRéessaie.",
    "editor.plugin.summary.ticker.button.generate": "Générer un résumé du liveticker",
    "editor.plugin.summary.ticker.button.replace": "Remplacer par un nouveau résumé",
    "editor.plugin.summary.ticker.longSummary": "Ticker continu",
    "editor.plugin.summary.ticker.longSummaryTooltip": "Ce bouton utilise un prompt IA optimisé pour sélectionner et résumer les entrées les plus pertinentes et les plus récentes du ticker couvrant plusieurs jours, voire plus.",
    "editor.plugin.summary.ticker.shortSummary": "Ticker événement",
    "editor.plugin.summary.ticker.shortSummaryTooltip": "Ce bouton utilise un prompt IA optimisé pour résumer des événements d'une durée d'une heure ou deux, comme les conférences de presse ou les événements sportifs.",
    "editor.plugin.summary.title": "Résumé",
    "editor.plugin.superscript.apply": "Exposant",
    "editor.plugin.superscript2.insert": "Exposant 2",
    "editor.plugin.superscript3.insert": "Exposant 3",
    "editor.plugin.threads.modal.edit": "Modifier le post Threads",
    "editor.plugin.threads.modal.insert": "Insérer un post Threads",
    "editor.plugin.threads.modal.submitButton": "Appliquer",
    "editor.plugin.threads.title": "Threads",
    "editor.plugin.tiktok.modal.edit": "Modifier le post TikTok",
    "editor.plugin.tiktok.modal.insert": "Insérer un post TikTok",
    "editor.plugin.tiktok.modal.submitButton": "Appliquer",
    "editor.plugin.tiktok.title": "Tiktok",
    "editor.plugin.twitter.modal.edit": "Modifier le post Twitter",
    "editor.plugin.twitter.modal.insert": "Insérer un post Twitter",
    "editor.plugin.twitter.modal.submitButton": "Appliquer",
    "editor.plugin.twitter.title": "X",
    "editor.plugin.ul.insert": "Liste à puces",
    "editor.plugin.underline.apply": "Souligné",
    "editor.plugin.videoCms.modal.edit": "Modifier la vidéo CMS",
    "editor.plugin.videoCms.modal.insert": "Ajouter un code embarqué VideoCMS",
    "editor.plugin.videoCms.modal.submitButton": "Appliquer",
    "editor.plugin.videoCms.title": "Video",
    "editor.plugin.videoCms.tooltip": "Pour afficher une vidéo, il faut utiliser le code embed Unity du CMS vidéo. Chaque vidéo a besoin d'une légende et d'une indication de la source. Les sources sont écrites comme suit: Vidéo: Nom de famille, nom (agence). Ou: Vidéo: Agence.",
    "editor.plugin.youtube.modal.edit": "Modifier le post YouTube",
    "editor.plugin.youtube.modal.insert": "Insérer un post YouTube",
    "editor.plugin.youtube.modal.submitButton": "Appliquer",
    "editor.plugin.youtube.title": "Youtube",
    "editor.plugin.zattoo.form.channel": "Sélectionner une chaîne Zattoo",
    "editor.plugin.zattoo.modal.edit": "Zattoo",
    "editor.plugin.zattoo.modal.insert": "Ajouter un code embarqué Zattoo",
    "editor.plugin.zattoo.modal.submitButton": "Appliquer",
    "editor.plugin.zattoo.title": "Zattoo",
    "editor.stickyToolbar.counter.element": "Caractères de l'élément: {{ quantity }}",
    "editor.stickyToolbar.counter.total": "Total de caractères: {{ quantity }}",
    "editor.stickyToolbar.counter.warning": "Le texte est plus long de 150 caractères que convenu. Raccourcis l'article.",
    "editor.validation.titleHeader.maxLength": "Le surtitre doit avoir un maximum de {{maxLength}} caractères",
    "editor.validation.uploading": "Il n’est pas possible de sauver tant que des éléments sont en cours de chargement.",
    "elementForm.modal.deleteMessage": "Le composant doit-il vraiment être supprimé? Le composant sera supprimé de tous les contenus.",
    "embed.captionTitle": "Titre de légende",
    "embed.code": "Code d'intégration",
    "embed.customJson.json": "JSON",
    "embed.fallBackHeight": "Hauteur de repli",
    "embed.frontendComponent.alt": "Contenu pour les moteurs de recherche",
    "embed.frontendComponent.label": "Label",
    "embed.frontendComponent.properties": "Propriétés",
    "embed.frontendComponent.source": "URL du script",
    "embed.iframe": "IFrame",
    "embed.iframe.preview.broken": "L'iFrame ne peut pas être affichée.",
    "embed.includeCaption": "Inclure la description",
    "embed.infobox.default": "Default",
    "embed.infobox.important": "Important",
    "embed.infobox.summary": "Résumé",
    "embed.url": "URL",
    "embeddedcontent.iframe.error": "Cette URL peut ne pas fonctionner. Elle doit être vérifiée dans l'aperçu.",
    "embeddedcontent.iframe.error.500": "Le serveur de Unity n'est momentanément pas disponible, stp réessayse plus tard",
    "embeddedSnippet.component": "Composant",
    "embeddedSnippet.copy": "Insérer une copie",
    "embeddedSnippet.copyedit.link": "Insère une copie du composant sélectionné pouvant être modifiée librement.",
    "embeddedSnippet.copyedit.unlink": "Intègre le composant sélectionné et le maintient synchronisé avec l’original. Modification impossible.",
    "embeddedSnippet.description": "Pour pouvoir éditer ce composant, le composant doit être copié. Les modifications apportées à la copie n'affectent pas le composant d'origine.",
    "embeddedSnippet.embed": "Intégrer l'original",
    "embeddedSnippet.noSelection": "Sélectionnez un composant pour afficher l’aperçu.",
    "embeddedSnippet.preview": "Aperçu",
    "emptySlideCredit": "Crédit manquant",
    "errorPage.button": "Retour à la page d'accueil",
    "errorPage.subtitle": "Désolé, une erreur est survenue. Clique sur le bouton pour retourner à la page d'accueil",
    "errorPage.title": "Oups!",
    "externalcontent.embeds.actions.create": "Créer un contenu embarqué",
    "externalcontent.embeds.detail.editButton": "Modifier les détails du contenu intégré",
    "externalcontent.embeds.detail.title": "Détails du contenu intégré",
    "externalcontent.embeds.form.lead": "Chapeau",
    "externalcontent.embeds.form.preview": "Aperçu",
    "externalcontent.embeds.form.title": "Titre",
    "externalcontent.embeds.form.titleHeader": "Surtitre",
    "externalcontent.embeds.form.url": "URL",
    "externalcontent.embeds.setup.pageTitle": "Nouveau contenu intégré",
    "externalcontent.embeds.title": "Contenus intégrés",
    "externalcontent.links.actions.create": "Créer un contenu externe",
    "externalcontent.links.detail.editButton": "Modifier les détails du lien externe",
    "externalcontent.links.detail.title": "Détails du lien externe",
    "externalcontent.links.form.openinnewwindow": "Ouvrir dans une nouvelle fenêtre",
    "externalcontent.links.form.url": "URL externe",
    "externalcontent.links.setup.pageTitle": "Nouveau lien externe",
    "externalcontent.links.title": "Liens externes",
    "externalcontent.links.type": "Type",
    "externalcontent.links.type.deepLink": "Deep Link",
    "externalcontent.links.type.url": "URL",
    "externalcontent.videos.detail.editButton": "Modifier les détails de la vidéo",
    "externalcontent.videos.detail.title": "Détails de la vidéo",
    "externalcontent.videos.list.createdButton": "Créer une vidéo",
    "externalcontent.videos.list.pageTitle": "Vidéos",
    "feedback.evaluation.downvote": "Vote négatif",
    "feedback.evaluation.upvote": "Vote positif",
    "fileUploadDropArea.ariaLabel": "Zone de dépôt d'image",
    "fileUploadDropArea.criteria.description": "Seuls les formats de fichier suivants sont autorisés dans la taille maximale indiquée ci-dessous:",
    "fileUploadDropArea.loading.status": "{{done}} sur {{total}} {{unit}} téléchargées ({{progress}}%)",
    "fileUploadDropArea.loading.status.bytes": "bytes",
    "fileUploadDropArea.loading.status.files": "fichiers",
    "fileUploadDropArea.loading.title": "Téléchargement",
    "fileUploadDropArea.multiple.text": "Déposer des images ici pour télécharger",
    "fileUploadDropArea.multiple.upload": "Télécharger des images",
    "fileUploadDropArea.single.text": "Déposer une image ici pour télécharger",
    "fileUploadDropArea.single.upload": "Télécharger une image",
    "form.cancelButton": "Annuler",
    "form.changes.restored": "Modifications non enregistrées restaurées",
    "form.closeButton.tooltip": "Fermer",
    "form.deleteButton": "Supprimer",
    "form.fields.error": "Erreur lors de la sauvegarde. Vérifie les données entrées.",
    "form.fields.urlIframe.placeholder": "URL ou Iframe (https)",
    "form.modal.cancelMessage": "Es-tu sûr(e) de vouloir annuler ? Tes changements seront perdus.",
    "form.modal.cancelTitle": "Annuler",
    "form.modal.deleteMessage": "Es-tu sûr de vouloir supprimer cet élément ?",
    "form.modal.deleteTitle": "Supprimer",
    "form.stepInput.decrease": "augmenter",
    "form.stepInput.increase": "réduire",
    "form.submitButton": "Enregistrer",
    "geneeaEntitiesAutocomplete.noneFound": "Aucune entité trouvée",
    "geneeaEntityForm.assignTag.hint": "Une fois que tu as attribué un tag, les articles marqués avec cette entité apparaîtront automatiquement sur la page du tag en question. La liste déroulante ci-dessus n'affiche que les entités auxquelles aucun tag n'a été attribuée.",
    "geneeaEntityForm.assignTag.label": "Tag",
    "geneeaEntityForm.assignTag.title": "Assigner un tag existant",
    "geneeaEntityForm.createTag.form.active": "Actif",
    "geneeaEntityForm.createTag.form.allowRobots": "Afficher dans les moteurs de recherche",
    "geneeaEntityForm.createTag.form.asyncvalidate.reject": "Ce nom est déjà utilisé",
    "geneeaEntityForm.createTag.form.description": "Description",
    "geneeaEntityForm.createTag.form.geneeaEntity.hint": "Les articles marqués avec cette entité apparaissent automatiquement sur la page de ce tag. Si vous ne le souhaitez pas, retirez l’entité ci-dessus et enregistrez les modifications.",
    "geneeaEntityForm.createTag.form.geneeaEntity.label": "Entité assignée",
    "geneeaEntityForm.createTag.form.image": "Image",
    "geneeaEntityForm.createTag.form.name": "Nom",
    "geneeaEntityForm.createTag.form.title": "Titre",
    "geneeaEntityForm.createTag.title": "Créer un nouveau tag",
    "geneeaEntityForm.or": "ou",
    "geneeaEntityList.filter.all": "Tous",
    "geneeaEntityList.filter.assigned": "Tag assigné",
    "geneeaEntityList.filter.unassigned": "Aucun tag",
    "geneeaEntityList.name": "Nom",
    "geneeaEntityList.tag": "Tag assigné",
    "geneeaEntityList.totalCount": "Nb d'articles",
    "geneeaEntityList.type": "Type",
    "home.title.greetings": "comment vas-tu aujourd'hui ?",
    "home.title.hello": "Salut {{name}},",
    "home.widget.releaseNotes": "Note de version",
    "home.widget.relevantSystems": "Systèmes pertinents",
    "icon.pin.title": "Épingler",
    "image.caption": "Légende",
    "image.credit": "Crédit",
    "image.description": "Description de l'image",
    "image.focusPoint.title": "Point focal",
    "image.style.image": "Image",
    "image.style.infographic": "Graphic",
    "kickword.edit.title": "Modifier le mot-clé",
    "kickword.form.asyncvalidate.reject": "Ce nom est déjà utilisé",
    "kickword.form.color.background": "Couleur du fond",
    "kickword.form.color.border": "Couleur de la bordure",
    "kickword.form.color.placeholder": "Code couleur hexadécimal (e.g. #DDEE55)",
    "kickword.form.color.text": "Couleur du texte",
    "kickword.form.name": "Nom",
    "kickword.list.addButton": "Créer un mot-clé",
    "kickword.setup.title": "Créer un mot-clé",
    "kickword.title": "Mots-clés",
    "league.edit.title": "Editer la ligue ou le tournoi",
    "league.form.nameEnglish": "Nom de la ligue ou du tournoi (Anglais)",
    "league.form.nameFrench": "Nom de la ligue ou du tournoi (Français)",
    "league.form.nameGerman": "Nom de la ligue ou du tournoi (Allemand)",
    "league.form.radio.item.iceHockey": "Hockey sur glace",
    "league.form.radio.item.soccer": "Football",
    "league.form.radio.title.sport": "Sport",
    "league.setup.title": "Créer une ligue ou un tournoi",
    "list.noresult": "Aucun résultat trouvé",
    "maintenancenotes.form.note": "Ajouter une note (écran d'accueil)",
    "maintenancenotes.form.notification": "Ajouter une note (barre de notification)",
    "maintenancenotes.form.status": "Status",
    "maintenancenotes.form.title": "Note de maintenance",
    "maintenancenotes.status.available": "Disponible",
    "maintenancenotes.status.maintenance": "Maintenance",
    "maintenancenotes.title": "Status du système Unity",
    "metadata.action.copy.success": "Copié avec succès !",
    "metadata.users.minCharacters": "Entre au moins 2 caractères",
    "metadata.users.nonefound": "Aucun utilisateur trouvé",
    "metadataHistory.closeButton.title": "Fermer",
    "metadataHistory.contentStatus": "Statut du contenu",
    "metadataHistory.fieldName": "Nom du champ",
    "metadataHistory.newValue": "Nouvelle valeur",
    "metadataHistory.operation": "Opération",
    "metadataHistory.operation.added": "Ajoutée",
    "metadataHistory.operation.removed": "Supprimé",
    "metadataHistory.operation.updated": "Actualisé",
    "metadataHistory.publicationStatus": "Statut de la publication",
    "metadataHistory.tenant": "Website / App",
    "metadataHistory.tenant.default": "Default",
    "metadataHistory.title": "Historique des métadonnées",
    "metadataHistory.updated": "Modifié",
    "metadataHistory.updatedBy": "Modifié par",
    "metadataHistory.value.off": "ÉTEINDRE",
    "metadataHistory.value.on": "ALLUMÉ",
    "metadataHistory.value.placeholder": "Ne peut pas être affichée ici",
    "metaform.additionalsettings.adsEnabled": "Afficher les publicités",
    "metaform.additionalsettings.aiGenerated": "Généré par l'IA",
    "metaform.additionalsettings.allowRobots": "Afficher dans les moteurs de recherche",
    "metaform.additionalsettings.authorBiographyDisplayed": "Afficher la biographie",
    "metaform.additionalsettings.breakingNews": "Breaking News",
    "metaform.additionalsettings.commentingEnabled": "Afficher les commentaires",
    "metaform.additionalsettings.commentRisk": "Comment risk",
    "metaform.additionalsettings.commentRisk.high": "Risque élevé",
    "metaform.additionalsettings.commentRisk.low": "Risque bas",
    "metaform.additionalsettings.confirmDisableAds.content": "Es-tu sûr de vouloir désactiver les publicités ?",
    "metaform.additionalsettings.confirmDisableAds.title": "Désactiver les publicités",
    "metaform.additionalsettings.contest": "Concours",
    "metaform.additionalsettings.feedbackEnabled": "Afficher feedback",
    "metaform.additionalsettings.group1": "Type de contenu",
    "metaform.additionalsettings.group2": "Contenu affiché",
    "metaform.additionalsettings.headDisabled": "Sans en-tête",
    "metaform.additionalsettings.likesEnabled": "Afficher Likes",
    "metaform.additionalsettings.live": "Direct",
    "metaform.additionalsettings.newsletterSubscribingEnabled": "Afficher l'inscription à la newsletter",
    "metaform.additionalsettings.opinion": "Opinion",
    "metaform.additionalSettings.opinion.tooltip": "Ce bouton indique que l'article est une opinion. Sélectionne le type de contribution d'opinion à l'aide du menu déroulant.",
    "metaform.additionalsettings.opinionType": "Type d'opinion",
    "metaform.additionalsettings.podcast": "Podcast",
    "metaform.additionalsettings.premium": "Premium",
    "metaform.additionalsettings.publicationDateExposed": "Afficher la date",
    "metaform.additionalsettings.readAloudEnabled": "Afficher la fonction de lecture audio",
    "metaform.additionalsettings.renderedInWebView": "App: ouvrir dans la vue web",
    "metaform.additionalsettings.sharingEnabled": "Afficher les partages",
    "metaform.additionalsettings.syndication": "Syndication",
    "metaform.additionalsettings.title": "Paramètres avancés",
    "metaform.additionalsettings.translation": "Traduction",
    "metaform.additionalsettings.videoInContent": "Vidéo",
    "metaform.additionalsettings.visibleInNewestContent": "Afficher dans les contenus les plus récents",
    "metaform.authors.addButton": "Ajouter",
    "metaform.authors.additionalInfo": "Info suppl.",
    "metaform.authors.agency": "Agence",
    "metaform.authors.author": "Auteur",
    "metaform.authors.contributor": "Contributeur",
    "metaform.authors.name": "Nom",
    "metaform.authors.photographer": "Photographe",
    "metaform.authors.removeButton": "Supprimer",
    "metaform.authors.service": "Service",
    "metaform.authors.title": "Auteurs",
    "metaform.authors.title.tooltip": "Tous les auteurs et autrices de l’article sont saisis ici. Pour ne pas faire apparaître un auteur ou une autrice dans la signature, mais lui permettre d'être enregistré par ProLitteris, le type contributeur peut être utilisé. Si une agence est ajoutée, seule son abréviation apparaîtra. Les auteurs et autrices qui ne figurent pas dans la liste déroulante peuvent être ajoutés en tant qu'auteurs externes. Pour ajouter des auteurs externes, veuillez contacter l'équipe produit dans ce canal Slack : #helpline_disco. <spacer /> <linkIcon /> <linkComponent href='https://tamedia.slack.com/archives/CTGHWRT3K'>Lien</linkComponent>",
    "metaform.authors.type": "Type",
    "metaform.category.notFoundContent": "Aucun résultat trouvé",
    "metaform.emailAlerts.label": "Activer l'envoi d'alerte par e-mail",
    "metaform.emailAlerts.tooltip.alreadyEnabled": "Envoi d'alerte par e-mail activé. Il ne peut pas être désactivé.",
    "metaform.emailAlerts.tooltip.disabled": "Au moins un tag doit être sélectionné pour que l'alerte par e-mail soit envoyée. Les alertes ne peuvent être envoyées qu'une seule fois par ticker.",
    "metaform.fixedmenubar.metadataHistory": "Historique des métadonnées",
    "metaform.fixedmenubar.placementHistory": "Historique des placements",
    "metaform.fixedmenubar.preview": "Afficher l'aperçu",
    "metaform.fixedmenubar.restore": "Restaurer",
    "metaform.fixedmenubar.save": "Enregistrer",
    "metaform.hreflang.addButton": "Ajouter",
    "metaform.hreflang.title": "Hreflang",
    "metaform.hreflang.title.tooltip": "Les balises Hreflang configurées ici sont transmises au site web avec le reste des métadonnées de l'article. Chaque ligne définit une locale (un ensemble composé d'une région et d'une langue) et une URL. Les moteurs de recherche utilisent ces données pour afficher dans les résultats de recherche l'URL correspondant à la localisation et à la langue actuelles de l'utilisateur ou de l'utilisatrice.",
    "metaform.infobox.button": "Ajouter une infobox",
    "metaform.infobox.field.content": "Contenu",
    "metaform.infobox.field.title": "Titre",
    "metaform.infobox.item.editButton": "Modifier l'Infobox",
    "metaform.infobox.modal.title": "Infobox",
    "metaform.infobox.title": "Infobox",
    "metaform.infobox.title.tooltip": "Cet encadré est toujours affiché à la fin de l'article, en mode déplié et avec un fond gris. À l'intérieur de cet encadré, tu peux utiliser tous les composants et éléments. Le titre est facultatif.",
    "metaform.kickword.nonefound": "Aucun autre mot-clé trouvé",
    "metaform.kickword.placeholder": "Sélectionner un mot-clé",
    "metaform.modal.confirm": "Confirmer",
    "metaform.note.placeholder": "Ajouter une note",
    "metaform.note.title": "Note",
    "metaform.note.title.tooltip": "Cette plage est uniquement destinée à un usage interne. Par exemple, pour des remarques si un contenu est dépublié ou pour des commentaires destinés à la correction. Ces notices ne sont affichées nulle part publiquement.",
    "metaform.placement.categories": "Catégories",
    "metaform.placement.categories.placeholder": "Sélectionner des catégories...",
    "metaform.placement.categories.tooltip": "L'article est placé dans chaque catégorie choisie, la catégorie principale devant être la plus adéquate. La catégorie principale est importante pour l'automatisation, les campagnes, le suivi et est mise en évidence dans la navigation.",
    "metaform.placement.editorialOrigin": "Origin éditoriale",
    "metaform.placement.editorialOrigin.agency": "Agence",
    "metaform.placement.editorialOrigin.mantel": "Rédaction nationale",
    "metaform.placement.editorialOrigin.mantel_reach": "Rédaction nationale + Reach",
    "metaform.placement.editorialOrigin.national": "National",
    "metaform.placement.editorialOrigin.reach": "Reach",
    "metaform.placement.editorialOrigin.regional": "Régional",
    "metaform.placement.editorialOrigin.regional_reach": "Régional + Reach",
    "metaform.placement.editorialOrigin.tooltip": "Cette distinction est importante pour l'analyse des données. Tous les textes pour les deux titres reçoivent la distinction «Rédaction nationale». Les dépêches de la ATS ou de l'AFP importées de BrixWire sont classées comme «Agence». Tous les textes du domaine Reach qui ne reposent pas sur des agences sont classés dans la catégorie «Reach». Tous les textes qui ne sont diffusés que pour un seul titre, car ils sont régionaux, reçoivent la catégorie «Régional».",
    "metaform.placement.mainCategory": "Catégorie principale",
    "metaform.placement.mainCategory.placeholder": "Sélectionner une catégorie principale...",
    "metaform.placement.tenantTitle": "Websites / Apps",
    "metaform.placement.tenantTitle.tooltip": "L'article sera publié pour tous les titres sélectionnés. Le site web principal est important pour le référencement naturel (SEO), il doit être sélectionné.",
    "metaform.placement.title": "Placement",
    "metaform.pollSettings.label": "Le vote dans sondages et notes activé",
    "metaform.pollSettings.title": "Sondages et notes",
    "metaform.pollSettings.tooltip": "Tant que le bouton ci-dessous est activée, les utilisateurs pourront voter dans toutes les notes et sondages dans ce contenu. Lorsqu'elle est désactivée, seuls les résultats sont affichés et il n'est plus possible de voter.",
    "metaform.printMetadata.category": "Catégorie",
    "metaform.printMetadata.desknetEntry": "Kordiam Contenu",
    "metaform.printMetadata.desknetEntryLink": "Lien vers le Kordiam",
    "metaform.printMetadata.desknetSync": "Activer la synchronisation avec Kordiam",
    "metaform.printMetadata.desknetSyncDisabled": "Synchronisation avec Kordiam activée",
    "metaform.printMetadata.desknetToolTip": "Ce bouton, une fois cliqué, active la synchronisation de ce contenu avec Kordiam. Une fois activée, elle ne peut pas être désactivée",
    "metaform.printMetadata.desknetToolTipDisabled": "La synchronisation de ce contenu avec Kordiam a été activée. Elle ne peut pas être désactivée",
    "metaform.printMetadata.pageName": "Nom de la page",
    "metaform.printMetadata.publication": "Marque",
    "metaform.printMetadata.publicationTargetDate": "Date cible de publication",
    "metaform.printMetadata.studioDossierId": "ID du dossier",
    "metaform.printMetadata.studioDossierLink": "Lien vers le dossier",
    "metaform.printMetadata.studioStatus": "Statut print",
    "metaform.printMetadata.studioSync": "Activer la synchronisation avec WW Studio",
    "metaform.printMetadata.studioSyncDisabled": "La synchronisation avec WW Studio activée",
    "metaform.printMetadata.studioToolTip": "Ce bouton, une fois cliqué, active la synchronisation de ce contenu WW Studio. Une fois activée, il ne peut pas être désactivé.",
    "metaform.printMetadata.studioToolTipDisabled": "La synchronisation de ce contenu avec WW Studio a été activée. Il ne peut pas être désactivé.",
    "metaform.printMetadata.targetDateTime": "Date cible et créneau horaire",
    "metaform.printMetadata.targetDateTime.tooltip": "La date cible et le temps cible déterminent l'ordre dans lequel la production et la correction lisent les contenus. Le moment est déterminé par la date de publication en ligne dans Kordiam.",
    "metaform.printMetadata.title": "Intégration avec print et planification",
    "metaform.printMetadata.type": "Type",
    "metaform.pushform.categories": "Catégories",
    "metaform.pushform.message.title": "Message",
    "metaform.pushform.modal.confirm": "Confirmer",
    "metaform.pushform.send": "Envoyer",
    "metaform.pushform.send.confirmationMessage": "Es-tu sûr de vouloir envoyer ce message ?",
    "metaform.pushform.send.disabled": "Merci de vérifier que le contenu est publié",
    "metaform.pushform.tenants": "Publications",
    "metaform.pushform.title": "Messages Push",
    "metaform.pushHistory.createdAt": "Envoyé à",
    "metaform.pushHistory.pushText": "Message",
    "metaform.pushHistory.refresh": "Actualiser les status",
    "metaform.pushHistory.title": "Historique des messages",
    "metaform.scheduledPlacing.customUpdatedAtError": "La date de mise à jour doit être plus tard que celle de publication",
    "metaform.scheduledPlacing.error.required": "Une date de publication ou une date d'expiration est requise",
    "metaform.scheduledPlacing.expiryTime": "Dépublier le",
    "metaform.scheduledPlacing.expiryTimeError": "L'expiration doit se situer plus tard que la publication",
    "metaform.scheduledPlacing.on": "Publication programmée",
    "metaform.scheduledPlacing.publicationTime": "Publier le",
    "metaform.scheduledPlacing.publishedOn": "Publié le",
    "metaform.scheduledPlacing.targetDateRequired": "Une date cible est requise",
    "metaform.scheduledPlacing.targetTextLength": "Nombre de caractères cible",
    "metaform.scheduledPlacing.targetTimeRequired": "Un créneau horaire est requise",
    "metaform.scheduledPlacing.targetUserNeed": "User need cible",
    "metaform.scheduledPlacing.title": "Planification",
    "metaform.scheduledPlacing.updatedNow": "Mis à jour maintenant",
    "metaform.scheduledPlacing.updatedOn": "Mis à jour le",
    "metaform.seoTeaser.button.generate": "Générer un teaser SEO",
    "metaform.seoTeaser.button.generate.tooltip": "Le teaser SEO ne peut pas être généré pour un article vide.",
    "metaform.seoTeaser.keywords.button.copy": "Copier du default teaser",
    "metaform.seoTeaser.keywords.button.error": "Une erreur s'est produite lors de la génération des mots-clés. Réessaie.",
    "metaform.seoTeaser.keywords.button.generate": "Générer des mots-clés et teaser SEO",
    "metaform.seoTeaser.keywords.button.generate.tooltip": "Les mots-clés ne peuvent pas être générés pour un article vide.",
    "metaform.seoTeaser.keywords.emptyKeyWords": "Le titre du teaser SEO est vide. Clique ici pour le remplir. Ou clique sur le bouton pour générer le texte et les mots-clés. Ils seront générés automatiquement lorsque la longueur cible sera atteinte.",
    "metaform.seoTeaser.keywords.title": "Suggestions de mots-clés",
    "metaform.seoTeaser.keywords.tooltip": "Il n'est pas nécessaire d'utiliser tous les mots-clés suggérés par ChatGPT. Important : Placez le mot-clé le plus important aussi tôt que possible. Plus d'informations et de conseils dans <spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1Sh6W2je2E6AMtUXLhNG86atksInlTNkGYdnMdWMnMlQ/'>le guide pratique SEO.</linkComponent>",
    "metaform.seoTeaser.modal.lead.tooltip": "Le chapeau SEO ne doit pas dépasser 140 caractères et doit commencer par les mots-clés les plus importants. Il doit être édité avant sa publication.",
    "metaform.seoTeaser.modal.title.tooltip": "Le titre SEO doit être unique, ne doit pas dépasser 60 caractères et doit impérativement commencer par les mots-clés les plus importants. Il doit être édité avant sa publication.",
    "metaform.seoTeaser.title": "Teaser SEO",
    "metaform.specialTeaser.button.generate": "Générer special teaser",
    "metaform.specialTeaser.button.generate.tooltip": "Le special teaser ne peut pas être généré pour un article vide.",
    "metaform.style.title": "Style",
    "metaform.styles.backgroundstory": "Background Story pleine largeur",
    "metaform.styles.backgroundstorywithads": "Background Story",
    "metaform.styles.commentary": "Teaser opinion avec l'image de l'auteur",
    "metaform.styles.default": "Default",
    "metaform.styles.focus": "Focus",
    "metaform.styles.fullwidth": "Largeur complète",
    "metaform.styles.label": "Styles",
    "metaform.styles.newsbriefing": "Newsbriefing",
    "metaform.styles.notFoundContent": "Aucun résultat trouvé",
    "metaform.styles.visual": "Visual",
    "metaform.tags.nonefound": "Aucun autre tag trouvé",
    "metaform.tags.placeholder": "Sélectionner des tags",
    "metaform.tags.title": "Tags",
    "metaform.tags.title.tooltip": "Les tags sont uniquement utilisés pour marquer les communes ou les formats. Les tags concernant les entreprises ne sont utilisés que par «Finanz und Wirtschaft».<spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1ZI1HIr6LidvIkl7WGdlDPYVoAU8bhJls0b84Oya6ckg/edit?usp=sharing'>Voici les règles en vigueur par rapport aux tags.</linkComponent>",
    "metaform.teaser.abtest.betaFeature": "Disponible uniquement pour les beta-testeurs pour le moment.",
    "metaform.teaser.abtest.results.significance.notSignificant": "Pas significatif",
    "metaform.teaser.abtest.results.significance.significant": "Significatif",
    "metaform.teaser.abtest.results.significance.tooltip": "Les trois valeurs possibles sont : très significatif (valeur-p inférieure ou égale à 0,01), significatif (p entre 0,01 et 0,05) et pas significatif (p supérieur à 0,05).",
    "metaform.teaser.abtest.results.significance.verySignificant": "Très significatif",
    "metaform.teaser.abtest.status": "Statut du test A/B",
    "metaform.teaser.abtest.status.completed": "Terminé",
    "metaform.teaser.abtest.status.initialized": "Crée",
    "metaform.teaser.abtest.status.running": "Commencé",
    "metaform.teaser.abtest.status.stopped": "Annulé",
    "metaform.teaser.abtest.versionA": "Version A",
    "metaform.teaser.abtest.versionA.edit": "Modifier la version teaser A",
    "metaform.teaser.abtest.versionB": "Version B",
    "metaform.teaser.abtest.versionB.cancel": "Annuler le test A/B",
    "metaform.teaser.abtest.versionB.cancel.confirm": "Es-tu sûr de vouloir annuler le test ? Cela supprimera la version B et tous les résultats. Tu peux alors commencer un nouveau test.",
    "metaform.teaser.abtest.versionB.create": "Créer un test A/B",
    "metaform.teaser.abtest.versionB.edit": "Modifier la version teaser B",
    "metaform.teaser.abtest.versionB.form.description": "Pour lancer un test A/B, mette à jour la version B ici. La version A est déjà créée à partir du teaser par défaut. Le test démarrera lorsque tu enregistres les modifications, publies l'article et le placés dans au moins une catégorie  pour lequel tests A/B sont autorisées. Au bout de 10 minutes, la version la plus consultée sera automatiquement définie comme nouveau teaser par défaut.",
    "metaform.teaser.abtest.versionB.remove": "Supprimer la version B",
    "metaform.teaser.abtest.versionB.remove.confirm": "Es-tu sûr de vouloir supprimer la version teaser B?  Tu peux alors commencer une nouvelle version.",
    "metaform.teaser.abtest.versionB.results.clicks": "Clicks",
    "metaform.teaser.abtest.versionB.seeResults": "Voir les résultats",
    "metaform.teaser.abtest.versionB.status.completed": "Test A/B terminé {{timestamp}}",
    "metaform.teaser.abtest.versionB.status.initialized": "Le test démarrera lorsque tu enregistres les modifications, publies l'article et le placés dans au moins une catégorie l'une catégories pour lequel tests A/B sont autorisées.",
    "metaform.teaser.abtest.versionB.status.running": "Test A/B commencé {{timestamp}}. Pour mettre à jour les teasers, annule d'abord le test. Disponible uniquement pour les beta-testeurs pour le moment.",
    "metaform.teaser.abtest.versionB.tooltip.disabled": "Le test A/B ne peut pas être crée si des variantes de teaser existent ou le teaser est vide. Supprime les variantes ou complète le teaser pour créer un test. Disponible uniquement pour les beta-testeurs pour le moment.",
    "metaform.teaser.abtest.versionB.tooltip.testRunning": "Les variantes de teaser ne peuvent pas être créées pendant l'exécution du test A/B",
    "metaform.teaser.allowAutomaticUpdate": "Synchronisation automatique avec le contenu",
    "metaform.teaser.emptyDescription": "La description de l'image est vide. Clique sur le teaser ci-dessus pour la remplir.",
    "metaform.teaser.imageDescription.size.error": "Teaser > Description de l'image doit être d'au maximum 1000 lettres ou symboles de long",
    "metaform.teaser.imageDescription.tooltip": "Le texte alternatif doit décrire de manière précise et concise le contenu de l'image, citer des personnes et des lieux identifiables et contenir des mots-clés SEO pertinents. Max. 150 caractères. Exemple : la candidate à la présidence Kamala Harris parle de Donald Trump lors d'un meeting de campagne à Detroit (États-Unis). <spacer /> Plus d'informations: <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1Sh6W2je2E6AMtUXLhNG86atksInlTNkGYdnMdWMnMlQ/'>guide pratique SEO.</linkComponent> ",
    "metaform.teaser.modal": "Modifier le teaser",
    "metaform.teaser.modal.adoptdefaults": "Synchroniser avec le teaser par défaut",
    "metaform.teaser.modal.adoptdefaults.tooltip": "Si l'image d'aperçu est vide, elle est toujours synchronisée et n'est pas contrôlée par ce bouton.",
    "metaform.teaser.modal.defaultTeaserRadio": "Teaser par défaut",
    "metaform.teaser.modal.deleteimage": "Supprimer l'image",
    "metaform.teaser.modal.embeddedContentRadio": "Contenu intégré",
    "metaform.teaser.modal.embedUrl": "Embed URL",
    "metaform.teaser.modal.image": "Image",
    "metaform.teaser.modal.lead": "Chapeau",
    "metaform.teaser.modal.lead.tooltip": "Le chapeau ne doit pas comporter plus de 180 caractères.",
    "metaform.teaser.modal.preview.1:1": "Opener Mobile, Regular, Card (1:1)",
    "metaform.teaser.modal.preview.16:9": "Opener Desktop (16:9)",
    "metaform.teaser.modal.preview.2:1": "2:1",
    "metaform.teaser.modal.preview.3:2": "Panorama (3:2)",
    "metaform.teaser.modal.preview.animated": "Ceci est une image animée et ne peut pas être découpée",
    "metaform.teaser.modal.preview.title": "Aperçu image à la une",
    "metaform.teaser.modal.refreshDescription": "Regénérer description de l'image",
    "metaform.teaser.modal.title": "Titre",
    "metaform.teaser.modal.title.tooltip": "Le titre ne doit pas comporter plus de 80 caractères.",
    "metaform.teaser.modal.titleHeader": "Surtitre",
    "metaform.teaser.modal.titleHeader.tooltip": "Le surtitre ne doit pas comporter plus de 30 caractères.",
    "metaform.teaser.modal.uploadimage": "Uploader une image",
    "metaform.teaser.special.tooltip": "Il s’agit de l’Open Graph (titre OG). L’Open Graph est utilisé pour les publications sur les médias sociaux. Ce titre est également affiché sur Google Discover.<spacer /> Plus d'informations: <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1Sh6W2je2E6AMtUXLhNG86atksInlTNkGYdnMdWMnMlQ/'>le guide pratique SEO.</linkComponent>",
    "metaform.teaser.title": "Teaser",
    "metaform.teaser.type.default": "Default teaser",
    "metaform.teaser.type.opengraph": "Special teaser",
    "metaform.url.description": "Component of the URL that describes the content. Allowed characters are a-z, 0-9 and -.",
    "metaform.url.editButton": "Modifier le slug URL",
    "metaform.url.example": "Example: {{url}}",
    "metaform.url.title": "URL slug",
    "metaform.validation.modal.adjust.description": "Pour modifier ce statut ou cette publication programmée, les champs suivants doivent être adaptés:",
    "metaform.validation.modal.description": "Afin de changer ce statut ou cette publication programmée, adapte les informations suivantes : ",
    "metaform.validation.modal.title": "Champs requis",
    "metaform.validation.unpublishModal.description": "Es-tu sûr de vouloir dépublier ce contenu ?",
    "modal.cancelButton": "Annuler",
    "modal.cloneContent.title": "Cloner le contenu",
    "modal.confirmButton": "Ok",
    "modal.deleteButton": "Supprimer",
    "modal.deleteContent.message": "Es-tu sûr de vouloir supprimer cet élément ?",
    "modal.deleteContent.title": "Supprimer",
    "modal.duplicateContent.content": "Es-tu sûr de vouloir dupliquer ce contenu ?",
    "modal.duplicateContent.title": "Dupliquer le contenu",
    "navigation.articles": "Articles",
    "navigation.back": "Retour",
    "navigation.breakingnews": "Breaking news",
    "navigation.categories": "Catégories",
    "navigation.collections": "Collection",
    "navigation.curatedList": "Liste sélectionnée",
    "navigation.embeds": "Contenu intégré",
    "navigation.geneeaEntities": "Entités Geneea",
    "navigation.kickwords": "Mots-clés",
    "navigation.links": "Liens externes",
    "navigation.newsletters": "Newsletters",
    "navigation.placement": "Placement",
    "navigation.rtelements": "Composants",
    "navigation.shortcuts": "Raccourcis clavier",
    "navigation.sitemaps": "Navigations",
    "navigation.slideshows": "Diaporamas",
    "navigation.tags": "Tags",
    "navigation.teams": "Equipes & joueurs",
    "navigation.tickers": "Liveticker",
    "navigation.users": "Comptes",
    "navigation.userSettings": "Mon compte",
    "navigation.videos": "Vidéo",
    "newsletter.relatedcontent.modal.title": "Sélectionner un contenu",
    "newsletters.edit": "Modifier la newsletter",
    "newsletters.hasConfig.title": "Cette newsletter apparaît sur une teaser.",
    "newsletters.list.tab.active": "Actif",
    "newsletters.list.tab.all": "Tout",
    "newsletters.list.tab.inactive": "Inactif",
    "newsletters.multipleSelected": "Dans le cas où plusieurs newsletters doivent être affichées sur une catégorie, l'une sera sélectionnée au hasard.",
    "newsletters.showCta": "Afficher le CTA de la newsletter sur le teaser de cet article",
    "newsletters.showSubscriptionsFromCategories": "Afficher l'inscription à la newsletter sur articles de ces catégories",
    "newVersion": "Il y a une nouvelle version Unity {{newVersion}} à dispo. Enregistre et <reloadLink>recharge la fenêtre du navigateur</reloadLink> !",
    "overviewList.actions.cloneArticleContent": "Cloner le contenu",
    "overviewList.actions.copyMetadataId": "Copier le id",
    "overviewList.actions.copyTextForAuthorisation": "Copier le texte pour autorisation",
    "overviewList.actions.delete": "Supprimer",
    "overviewList.actions.duplicate": "Dupliquer",
    "overviewList.author": "Auteur",
    "overviewList.characters": "Caractères",
    "overviewList.contentStatus": "Statut du contenu",
    "overviewList.createdAt": "Créé",
    "overviewList.createdBy": "Auteur",
    "overviewList.endTime": "Terminé",
    "overviewList.image": "Image à la une",
    "overviewList.itemsOnTheList": "{{totalElements}} éléments sur la liste",
    "overviewList.printDate": "Date print",
    "overviewList.publicationStatus": "Statut de publication",
    "overviewList.refreshedSecondsAgo": "Actualisé il y a {{seconds}} seconde(s)",
    "overviewList.results": "Résultats",
    "overviewList.significance": "Signification",
    "overviewList.startTime": "Commencé",
    "overviewList.status": "Statut",
    "overviewList.targetTime": "Temps cible",
    "overviewList.teaserImageA": "Image A",
    "overviewList.teaserImageB": "Image B",
    "overviewList.titleHeaderAndTitle": "Surtitre et titre",
    "overviewList.titleHeaderAndTitleA": "Surtitre et titre A",
    "overviewList.titleHeaderAndTitleB": "Surtitre et titre B",
    "overviewList.updatedAt": "Modifié",
    "overviewList.users": "Utilisé par",
    "page.navigation.detail": "Contenu",
    "page.navigation.metadata": "Metadonnées",
    "page.navigation.pushmessages": "Push",
    "page.setupForm.submitButton": "Créer",
    "page.setupForm.title": "Configuration",
    "page.title.articles": "Articles",
    "page.title.breakingnews": "Breaking news",
    "page.title.categories": "Catégories",
    "page.title.collections": "Collection",
    "page.title.curatedList": "Liste sélectionnée",
    "page.title.externalContent.embeds": "Contenu intégré",
    "page.title.externalContent.links": "Liens externes",
    "page.title.externalContent.videos": "Vidéo",
    "page.title.home": "Accueil",
    "page.title.kickwords": "Mots-clés",
    "page.title.placement": "Placement",
    "page.title.rtelements": "Composants",
    "page.title.sitemaps": "Navigations",
    "page.title.slideshows": "Diaporamas",
    "page.title.tags": "Tags",
    "page.title.teams": "Equipes & joueurs",
    "page.title.tickers": "Liveticker",
    "page.title.users": "Comptes",
    "page.title.userSettings": "Mon compte",
    "placement.columnheader.modal.config.allowAbTest": "Les tests A/B sont autorisés dans cette page.",
    "placement.drop.modal.move.confirm": "Déplacer",
    "placement.drop.modal.replace.confirm": "Remplacer",
    "placement.dropFromPinned.modal.description": "<paragraph>Le contenu <component>\"{{contentTitle}}\"</component> sera déplacé.</paragraph>",
    "placement.dropFromPinned.modal.title": "Déplacer le contenu épinglé ?",
    "placement.dropFromPlaceholder.modal.description": "<paragraph>Le placeholder <component>{{categoryName}}</component> sera déplacé.</paragraph>",
    "placement.dropFromPlaceholder.modal.title": "Déplacer le contenu placeholder ?",
    "placement.dropOnPinned.modal.description": "<paragraph>Le contenu <component>\"{{contentTitle}}\"</component> sera remplacé.</paragraph>",
    "placement.dropOnPinned.modal.title": "Remplacer le contenu épinglé ?",
    "placement.dropOnPlaceholder.modal.description": "<paragraph>Le placeholder <component>{{categoryName}}</component> sera remplacé.</paragraph>",
    "placement.dropOnPlaceholder.modal.title": "Remplacer le contenu placeholder ?",
    "placement.premiumContentBadge": "Abo",
    "placement.premiumContentBadge.tooltip": "Contenu premium",
    "placement.section.copy.DEFAULT_SECTION_CANNOT_BE_COPIED.error": "Les sections par défaut ne peuvent pas être copiées.",
    "placement.section.copy.REMOVED_BUTTON.warning": "La catégorie définie dans cette section n'est pas présente dans navigation de {{tenantName}}.  Le bouton a été désactivé dans la copie de la section.",
    "placement.section.copy.REMOVED_CONTENT.warning": "Pour au moins un article, le tenant {{tenantName}} est manquant. La section a été créée sans celui-ci. Pour placer l'article, il faut d'abord ajouter le tenant et ensuite placer l'article manuellement par glisser-déposer.",
    "placement.section.copy.REMOVED_PLACEHOLDERS.warning": "Le placeholder dans la section fait référence à la même catégorie que la page cible ou n'est pas présente dans navigation de {{tenantName}}. Le placeholder a été supprimé de la copie.",
    "placement.section.copy.SECTION_CANNOT_BE_COPIED_TO_ITS_REFERENCED_PAGE.error": "La catégorie définie dans cette section est la même que celle de la page cible. Dans ce cas, la copie n'est pas possible.",
    "placement.section.copy.SECTION_CATEGORY_IS_MISSING_IN_THE_TARGET_SITEMAP.error": "La catégorie définie dans cette section n'est pas présente dans navigation de {{tenantName}}. Pour copier l'article, il faut d'abord ajouter élément pour cette catégorie et ensuite placer la section manuellement par glisser-déposer.",
    "placementHistory.chart.now": "Maintenant",
    "placementHistory.chart.positionInCategory": "Position dans la catégorie",
    "placementHistory.chart.positionInSection": "Position dans la section",
    "placementHistory.chart.time": "Temps",
    "placementHistory.chart.title": "Graphique de l'historique des placements",
    "placementHistory.closeButton.title": "Fermer",
    "placementHistory.title": "Historique des placements",
    "placementHistory.toolbar.dateRange.clear": "Effacer",
    "placementHistory.toolbar.tenant": "Publication",
    "placementtool.column.by": "par",
    "placementtool.column.category.placeholder": "Catégorie",
    "placementtool.column.createButton": "Créer une colonne",
    "placementtool.column.drop.error.addTenantFirst": "Merci d'ajouter d'abord la publication \"{{ tenantName }}\" dans les métadonnées.",
    "placementtool.column.fullDatePrefix": "à",
    "placementtool.column.lastPublished": "Default dernière publication",
    "placementtool.column.pageType.category.label": "Catégorie",
    "placementtool.column.pageType.label": "Type de page",
    "placementtool.column.pageType.tag.label": "Tag",
    "placementtool.column.tag.placeholder": "Tag",
    "placementtool.column.toolbar.section.create": "Créer une section",
    "placementtool.column.toolbar.submitButton": "publier",
    "placementtool.columnheader.closeButton.tooltip": "Fermer",
    "placementtool.columnheader.config.title": "Configuration",
    "placementtool.columnheader.modal.notPublished": "Non publié !",
    "placementtool.columnheader.modal.notPublished.continue": "Les modifications ne sont pas publiées ! Continuer tout de même ?",
    "placementtool.columnheader.tenant": "Publication",
    "placementtool.contentItem.deleted": "supprimé",
    "placementtool.contentItem.notPublishedYet": "Pas encore publié",
    "placementtool.contentItem.unpublished": "dépublié",
    "placementtool.drop.hint": "Déposer l'élément ici",
    "placementtool.history": "Historique",
    "placementtool.history.by": "par",
    "placementtool.history.modal.message": "Confirmer va écraser le travail en cours. Ceci ne peut pas être annulé. Cela doit toujours être publié.",
    "placementtool.history.modal.title": "Attention",
    "placementtool.metadatalist.articles.title": "Tous les articles",
    "placementtool.metadatalist.bookmarks.title": "Favoris",
    "placementtool.placeholderModal.title.create": "Créer un placeholder",
    "placementtool.placeholderModal.title.edit": "Editer le placeholder",
    "placementtool.section.content_block": "Texte enrichi",
    "placementtool.section.external_widget": "Recommender",
    "placementtool.section.no_logic": "Container vide",
    "placementtool.section.ta-placement-engine": "TGD Recommender",
    "placementtool.sectionForm.adPositionsSection.title": "Positions des pubs",
    "placementtool.sectionForm.adsPositions.desktop": "Sur Desktop",
    "placementtool.sectionForm.appearanceSection.title": "Apparence",
    "placementtool.sectionForm.backgroundColor": "Couleur du fond",
    "placementtool.sectionForm.backgroundColor.blue": "Bleu",
    "placementtool.sectionForm.backgroundColor.brown": "Marron",
    "placementtool.sectionForm.backgroundColor.green": "Vert",
    "placementtool.sectionForm.backgroundColor.mint": "Menthe",
    "placementtool.sectionForm.backgroundColor.neutral": "Neutre",
    "placementtool.sectionForm.backgroundColor.none": "Aucune",
    "placementtool.sectionForm.backgroundColor.orange": "Orange",
    "placementtool.sectionForm.backgroundColor.pink": "Rose",
    "placementtool.sectionForm.backgroundColor.purple": "Violet",
    "placementtool.sectionForm.backgroundColor.tenantColor": "Couleur de la publication",
    "placementtool.sectionForm.buttonLink.categoryLink.label": "Catégorie",
    "placementtool.sectionForm.buttonLink.internalLink.label": "Internal link",
    "placementtool.sectionForm.buttonLink.label": "Lien du bouton",
    "placementtool.sectionForm.buttonLink.link.label": "External link",
    "placementtool.sectionForm.buttonLink.tagLink.label": "Tag",
    "placementtool.sectionForm.buttonSection.title": "Bouton",
    "placementtool.sectionForm.buttonTextField.label": "Texte du bouton",
    "placementtool.sectionForm.categories.label": "Référence de catégorie",
    "placementtool.sectionForm.categoryToBeLinkedTo.label": "Lier une catégorie",
    "placementtool.sectionForm.content.label": "Contenu",
    "placementtool.sectionForm.customTypeIdentifier.label": "Identificateur",
    "placementtool.sectionForm.defaultCategory.label": "Catégorie par défaut",
    "placementtool.sectionForm.freshPin.label": "Favoriser les contenus récents",
    "placementtool.sectionForm.isButtonVisible.label": "Afficher le bouton",
    "placementtool.sectionForm.isInfiniteScroll.label": "Scroll infini",
    "placementtool.sectionForm.isSectionVisible.label": "Afficher la section",
    "placementtool.sectionForm.layouts.default": "Default",
    "placementtool.sectionForm.layouts.label": "Structure de section",
    "placementtool.sectionForm.layouts.newfront_bundle": "Bundle",
    "placementtool.sectionForm.layouts.newfront_highlight": "Highlight",
    "placementtool.sectionForm.layouts.newfront_horizontal-scroll": "Horizontal Scroll",
    "placementtool.sectionForm.layouts.newfront_horizontal-stacked": "Horizontal Stacked",
    "placementtool.sectionForm.layouts.newfront_latest-news": "Dernières nouvelles",
    "placementtool.sectionForm.layouts.newfront_list": "List",
    "placementtool.sectionForm.layouts.newfront_micro": "Micro",
    "placementtool.sectionForm.layouts.newfront_newsbriefing": "L'essentiel du jour",
    "placementtool.sectionForm.layouts.newfront_opener-list": "Opener List",
    "placementtool.sectionForm.layouts.newfront_opener-overview": "Opener Overview",
    "placementtool.sectionForm.layouts.newfront_opener-top": "Opener Top",
    "placementtool.sectionForm.layouts.newfront_panorama": "Panorama",
    "placementtool.sectionForm.layouts.newfront_standard-even": "Standard Even",
    "placementtool.sectionForm.layouts.newfront_standard-uneven": "Standard Uneven",
    "placementtool.sectionForm.navigationLayout.dropdown": "Dropdown Layout",
    "placementtool.sectionForm.navigationLayout.link": "Link Layout",
    "placementtool.sectionForm.recommenderSection.title": "Moteur de recommandation",
    "placementtool.sectionForm.searchText.label": "Texte de recherche",
    "placementtool.sectionForm.selectableCategories.label": "Catégories sélectionnables",
    "placementtool.sectionForm.showTitle.label": "Afficher le titre",
    "placementtool.sectionForm.subtitle.label": "Sous-titre",
    "placementtool.sectionForm.tag.label": "Référence du tag",
    "placementtool.sectionForm.tagToBeLinkedTo.label": "Lier le tag",
    "placementtool.sectionForm.teaserCount.label": "Nombre de contenus",
    "placementtool.sectionForm.url.label": "Lien URL",
    "placementtool.sectionForm.weightMomentum.label": "Poids de momentum",
    "placementtool.sectionForm.weightPerformance.label": "Poids de performance",
    "placementtool.sectionForm.weightRecency.label": "Poids de récence",
    "placementtool.sectionForm.weightSemantic.label": "Poids sémantique",
    "placementtool.sectionForm.widgetId.label": "Widget ID",
    "placementtool.sectionModal.add.title": "Ajouter une section",
    "placementtool.sectionModal.closeButton.tooltip": "Fermer",
    "placementtool.sectionModal.edit.title": "Modifier la section",
    "placementtool.sectionModal.form.submitButton": "Enregistrer",
    "placementtool.sectionModal.titleField.label": "Titre",
    "placementtool.sectionModal.type.category": "Catégorie",
    "placementtool.sectionModal.type.category.new": "Toujours montrer le premier contenu de la catégorie…",
    "placementtool.sectionModal.type.content_block": "Texte enrichi",
    "placementtool.sectionModal.type.custom": "Personnalisée",
    "placementtool.sectionModal.type.default": "Valeur par défaut",
    "placementtool.sectionModal.type.external_widget": "Recommender",
    "placementtool.sectionModal.type.label": "Type",
    "placementtool.sectionModal.type.no_logic": "Container vide",
    "placementtool.sectionModal.type.ta-placement-engine": "TGD Recommender",
    "placementtool.sectionModal.type.tag": "Tag",
    "placementtool.sectionModal.type.user_category_selection": "Plusieurs catégories",
    "placementtool.sectionpresets.add.button": "Enregistrer cette vue",
    "placementtool.sectionpresets.input.placeholder": "Entrer un label",
    "placementtool.sections.collapseAll": "Tout replier",
    "placementtool.sections.expandAll": "Tout déplier",
    "preview.error.metadata": "Metadonnées n'ont pas été trouvées.",
    "preview.error.notAvailable": "L'aperçu n'est pas disponible",
    "preview.input.error.max.height": "Hauteur maximum: {{maxSize}}",
    "preview.input.error.max.width": "Largeur maximum: {{maxSize}}",
    "preview.input.error.min.height": "Hauteur minimum: {{minSize}}",
    "preview.input.error.min.width": "Largeur minimum: {{minSize}}",
    "preview.pageHeader.title": "Aperçu",
    "preview.pageHeader.tooltip": "L'aperçu n'affiche pas tes dernières modifications? Il faut un certain temps avant que les modifications soient visibles dans l'aperçu. Assure-toi d'avoir sauvegardé toutes les modifications avant d'appuyer sur le bouton “afficher l’aperçu”, sinon elles ne seront pas visibles. Tu peux forcer une actualisation avec ctrl+shift+R / cmd+shift+R. Ou si l'article est créé pour plus d'un titre, essaie de changer le titre dans le menu déroulant, cela aide à actualiser l'aperçu.",
    "publicationStatus": "Statut de la publication",
    "publicationStatus.internalOnly": "IA interne uniquement",
    "publicationStatus.internalOnly.tooltip": "Invisible pour les utilisateurs, utilisable par l’IA interne.",
    "publicationStatus.notPublished": "Non publié",
    "publicationStatus.notPublished.tooltip": "Non public, non indexé, aucune utilisation par l’IA.",
    "publicationStatus.published": "Publié",
    "publicationStatus.published.tooltip": "Public, indexé et accessible par l’IA interne.",
    "publicationStatus.unlisted": "Pas dans Google",
    "publicationStatus.unlisted.tooltip": "Visible via lien direct uniquement, non indexé, IA interne autorisée.",
    "publicationStatus.unpublished": "Supprimé",
    "publicationStatus.unpublished.tooltip": "Supprimé et totalement inaccessible.",
    "pushHistory.streamboat.noStatus": "Aucun statut disponible pour Streamboat.",
    "pushStatus.description.externalError": "<p><strong>Echec temporaire</strong> de la vérification du status.</p>",
    "pushStatus.description.failed": "<p><strong>Echec</strong> de l'envoi du message. Aucun message n'a été envoyé aux abonnés.</p>",
    "pushStatus.description.finished": "<p><strong>Terminé</strong> l'envoi du message aux abonnés.</p> <p>L'envoi a pris {{duration}} minutes.</p>",
    "pushStatus.description.sending": "<p><strong>Envoi</strong> du message aux abonnés.</p> <p>L'envoi dure depuis {{duration}} minutes.</p>",
    "pushStatus.description.unknown": "Une erreur inconnue est survenue.",
    "pushStatus.externalError": "Erreur externe",
    "pushStatus.failed": "Echec",
    "pushStatus.finished": "Terminé",
    "pushStatus.sending": "Envoi",
    "pushStatus.unknown": "Inconnu",
    "releaseNotes.btnCreate": "Un nouvelle",
    "releaseNotes.form.labelEdit": "Modifier la note",
    "releaseNotes.form.labelNew": "Ajouter une note",
    "releaseNotes.noContent": "Aucun contenu",
    "releaseNotes.title": "Note de version",
    "releaseNotes.visible": "Visible",
    "revision.currentTag": "Révision actuelle",
    "revision.modal.confirmationMessage": "Es-tu sûr(e) de vouloir restaurer cette révision ?",
    "revision.modal.confirmButton": "Restaurer",
    "revision.modal.newRevisionMessage": "Une nouvelle révision sera créée sur cette base.",
    "revision.modal.title": "Restaurer révision",
    "revision.modal.unpublishMessage": "L'article sera dépublié",
    "revision.restoreTag": "Deviendra une nouvelle révision lors de la restauration",
    "richtext.error.critical": "Une erreur s'est produite lors de la sauvegarde du champ.",
    "richtext.warning.restore": "Un problème avec l'éditeur est survenu. Le dernier contenu connu a été restauré.",
    "router.modal.content": "Tes modifications ne sont pas enregistrées. <br/> Tu veux vraiment fermer cette page et continuer sans enregistrer?",
    "router.modal.leave": "Oui, quitter la page sans enregistrer",
    "router.modal.stay": "Non, retour en arrière",
    "router.modal.title": "Attention, Unity signale:",
    "rtElement.form.infobox.name": "Nom",
    "rtElement.form.infobox.tenants": "Publications",
    "rtElement.form.title.create": "Créer un composant",
    "rtElement.form.title.edit": "Modifier",
    "rtElement.name": "Nom",
    "rtElement.tenants": "Publications",
    "rtElements.list.addButton": "Créer un composant",
    "rtElements.list.title": "Composants",
    "rtElements.type.snippet": "Extrait",
    "scoreboard.resultAdditive.ot": "ap",
    "scoreboard.resultAdditive.so": "tb",
    "scoreboardForm.resultAdditive.label": "Résultat final complément",
    "scoreboardForm.resultAdditive.ot": "Après prolongation (ap)",
    "scoreboardForm.resultAdditive.so": "Après tirs au but (tb)",
    "search.authors.label": "Utilisateur/agence",
    "search.authors.nonefound": "Aucun(e) utilisateur/agence trouvé(e)",
    "search.category.label": "Catégories",
    "search.contentStatus.label": "Statuts du contenu",
    "search.contentType.label": "Types de contenu",
    "search.filterButton.less": "Filtres simples",
    "search.filterButton.more": "Filtres avancés",
    "search.filterButton.reset": "Réinitialiser les filtres",
    "search.leagues.iceHockey.label": "Ligues",
    "search.leagues.soccer.label": "Leagues",
    "search.leagues.tennis.label": "Modes",
    "search.main.label": "Recherche",
    "search.minCharacters": "Entre au moins 2 caractères.",
    "search.publicationStatus.label": "Statuts de la publication",
    "search.publishedAfter.label": "Publié depuis",
    "search.publishedBefore.label": "Publié jusq’au",
    "search.tab.keyword": "Recherche par mot-clé",
    "search.tab.semantic": "Recherche sémantique",
    "search.tags.label": "Tags",
    "search.tenants.label": "Publications",
    "semanticSearch.loadMore": "Charger plus",
    "semanticSearch.slider.almostSame": "presque pareil",
    "semanticSearch.slider.similar": "similaire",
    "semanticSearch.slider.slightlySimilar": "un peu similaire",
    "semanticSearch.slider.verySimilar": "très similaire",
    "semanticSearch.tooltip": "La recherche sémantique se distingue nettement de la recherche par mots-clés. Elle ne vérifie pas la correspondance de lettres ou de mots, mais peut aussi trouver des synonymes et des concepts apparentés. Lors de la recherche d'un mot comme «fruit», on trouve également des textes contenant uniquement des termes apparentés comme «pomme» ou «poire». La recherche sémantique permet de définir le degré de similarité – c'est-à-dire à quel point les textes trouvés correspondent du point de vue thématique à la requête. On peut aussi rechercher avec du contexte ou des questions. <br/> <strong>Exemple</strong>: la recherche d'articles sur «les problèmes de circulation dans la commune». La recherche sémantique ne trouve pas seulement des textes contenant exactement ces mots, mais aussi des articles sur les embouteillages sur la route cantonale, le manque de places de parc près de la gare, le débat autour de la zone 30 ou la desserte par les transports publics problématique - c’est-à-dire des contenus pertinents sur le même thème, même si d'autres termes ont été utilisés.",
    "shortcuts.action.bold": "Gras",
    "shortcuts.action.cancel": "Annuler",
    "shortcuts.action.cycleRegion": "Parcourir les régions de la page",
    "shortcuts.action.focusContentStatus": "Activer le statut du contenu",
    "shortcuts.action.focusPublicationStatus": "Activer le statut de publication",
    "shortcuts.action.insertMenuSwitchColumn": "Menu d'insertion : changer de colonne",
    "shortcuts.action.insertMenuSwitchTab": "Menu d'insertion : changer d'onglet",
    "shortcuts.action.italic": "Italique",
    "shortcuts.action.link": "Insérer ou modifier un lien",
    "shortcuts.action.metadataHistory": "Ouvrir l'historique des métadonnées",
    "shortcuts.action.moveElementDown": "Déplacer l'élément vers le bas",
    "shortcuts.action.moveElementUp": "Déplacer l'élément vers le haut",
    "shortcuts.action.openComments": "Ouvrir les commentaires",
    "shortcuts.action.openInsertMenu": "Ouvrir le menu d'insertion d'élément",
    "shortcuts.action.openMetadataFromOverview": "Ouvrir les métadonnées depuis l'aperçu",
    "shortcuts.action.openSpellChecker": "Ouvrir le correcteur d'orthographe",
    "shortcuts.action.orderedList": "Liste numérotée",
    "shortcuts.action.placementHistory": "Ouvrir l'historique des placements",
    "shortcuts.action.preview": "Ouvrir l'aperçu",
    "shortcuts.action.rephrase": "Reformuler le paragraphe",
    "shortcuts.action.save": "Enregistrer",
    "shortcuts.action.showShortcuts": "Afficher les raccourcis clavier",
    "shortcuts.action.subscript": "Indice",
    "shortcuts.action.superscript": "Exposant",
    "shortcuts.action.switchTabContent": "Aller à l'onglet Contenu",
    "shortcuts.action.switchTabPublication": "Aller à l'onglet Publication",
    "shortcuts.action.switchTabPush": "Aller à l'onglet Push",
    "shortcuts.action.underline": "Souligné",
    "shortcuts.action.unorderedList": "Liste à puces",
    "shortcuts.category.editor": "Éditeur",
    "shortcuts.category.navigation": "Navigation",
    "shortcuts.category.page": "Actions de page",
    "shortcuts.dialog.closeButton.title": "Fermer",
    "shortcuts.dialog.title": "Raccourcis clavier",
    "showmore.title.closed": "Afficher plus",
    "showmore.title.open": "Afficher moins",
    "sitemap.edit.defaultTitle": "Ajouter un nouvel élément",
    "sitemap.edit.title": "Modifier l'élément",
    "sitemap.fixedmenubar.restore": "Restaurer",
    "sitemap.fixedmenubar.save": "Enregistrer",
    "sitemap.form.allowRobots": "Afficher dans les moteurs de recherche",
    "sitemap.form.availableFor": "Disponible pour",
    "sitemap.form.availableFor.app": "App",
    "sitemap.form.availableFor.desktop": "Desktop",
    "sitemap.form.categoryReference": "Référence de catégorie",
    "sitemap.form.categoryUrlPath": "URL slug",
    "sitemap.form.clientPageIdentifier": "Identifier",
    "sitemap.form.clientPagePath": "Path",
    "sitemap.form.contentLink": "URL externe",
    "sitemap.form.contentReference": "Référence de contenu",
    "sitemap.form.contentUrlSlug": "URL slug",
    "sitemap.form.contentUrlSlug.description": "Ceci va écraser le slug de l'URL du contenu sélectionné.",
    "sitemap.form.icon": "Icône",
    "sitemap.form.indexing": "Indexation",
    "sitemap.form.metaDescription": "Meta description",
    "sitemap.form.metaTitle": "Meta title",
    "sitemap.form.modal.deleteMessage": "Si cet élément du sitemap est supprimé et contient des sous-éléments, ils seront supprimés également. Cela s'applique aussi aux menus.",
    "sitemap.form.name": "Nom affiché",
    "sitemap.form.newWindow": "Ouvrir dans une nouvelle fenêtre",
    "sitemap.form.nodeType": "Type d'élément",
    "sitemap.form.notFoundContent": "Catégorie introuvable",
    "sitemap.form.pageStyle.caption": "Style de la page",
    "sitemap.form.pageStyle.dasMagazin": "Das Magazin",
    "sitemap.form.pageStyle.default": "Default",
    "sitemap.form.pageStyle.video": "Video",
    "sitemap.form.pageStyle.zueriTipp": "Züritipp",
    "sitemap.form.subtitle": "Sous-titre",
    "sitemap.form.tagReference": "Référence de tag",
    "sitemap.form.tagUrlSlug": "Slug d'URL",
    "sitemap.form.tagUrlSlug.description": "Partie de l'URL qui décrit le contenu. Caractères autorisés : a-z, 0-9 et -. Elle est toujours précédée de l'identifiant \"tags/\". Exemple : …/tags/nom-de-votre-tag",
    "sitemap.form.type.category": "Catégorie",
    "sitemap.form.type.clientPage": "Static page",
    "sitemap.form.type.content": "Contenu",
    "sitemap.form.type.external": "Lien externe",
    "sitemap.form.type.group": "Groupe d'éléments",
    "sitemap.form.type.tag": "Tag",
    "sitemap.list.addButton": "Ajouter",
    "sitemap.list.placeholder.name": "(Nouvel élément)",
    "sitemap.menu.cancelButton": "Restaurer",
    "sitemap.menu.highlighted": "Mis en évidence",
    "sitemap.menu.labels.footer": "Pied de page",
    "sitemap.menu.labels.menu": "Menu",
    "sitemap.menu.labels.menuFooter": "Pied du menu",
    "sitemap.menu.labels.topNavigation": "Navigation principale",
    "sitemap.menu.labels.userPanel": "Panneau utilisateur",
    "sitemap.menu.modal.deleteButton": "Supprimer l'élément",
    "sitemap.menu.modal.submitButton": "Appliquer",
    "sitemap.menu.modal.title": "Modifier l'élément de menu",
    "sitemap.menu.placeholder": "Sélectionner le menu",
    "sitemap.menu.submitButton": "Enregistrer",
    "sitemap.menu.title": "Menus",
    "sitemap.tenantSelector.placeholder": "Publication",
    "slidelist.validation.message": "Il y a des slides avec des informations manquantes",
    "slideshow.bulkSlideForm.title": "Éditer toutes les slides",
    "slideshow.detail.editButton": "Modifier les détails du diaporama",
    "slideshow.detail.title": "Détails du diaporama",
    "slideshow.editorPlugin.preview.noSlideLink": "Modifier le diaporama",
    "slideshow.editorPlugin.preview.noSlideMessage": "Il n'y a pas de slide dans ce diaporama.",
    "slideshow.form.lead": "Chapeau",
    "slideshow.form.title": "Titre",
    "slideshow.form.titleHeader": "Surtitre",
    "slideshow.list.createButton": "Créer un diaporama",
    "slideshow.navigation.next": "Suivant",
    "slideshow.navigation.previous": "Précédent",
    "slideshow.router.modal.content": "Les descriptions ne sont pas encore générées pour toutes les slides. Si tu quittes maintenant, elles resteront vides. <br/> Tu veux vraiment fermer cette page et continuer sans enregistrer?",
    "slideshow.setup.pageTitle": "Nouveau diaporama",
    "slideshow.slideform.invalidTooltip": "Pour définir le teaser, toutes les slides doivent être valides.",
    "slideshow.slideform.setImage": "Définir cette image en tant que teaser",
    "slideshow.slideform.title": "Éditer la slide",
    "slideshow.slideform.visible": "Visible",
    "slideshow.slidelist.addButton": "Créer une slide",
    "slideshow.slidelist.editAll": "Éditer toutes",
    "slideshow.slidelist.restore": "Restaurer",
    "slideshow.slidelist.save": "Enregistrer l'ordre",
    "slideshow.slidelist.saveOrder": "Sauver l'ordre d'abord",
    "slideshow.slidelist.title": "Slides ({{quantity}})",
    "spellchecker.error.overload.message": "La correction d'orthographe est actuellement surchargée. Réessaie plus tard.",
    "spellchecker.error.timeout.message": "La correction d'orthographe a pris plus de temps que d'habitude et a échoué. Réessaie.",
    "statusSelect.disabled.tooltip": "Pour changer de statut, enregistre d'abord.",
    "tag.description": "Description",
    "tag.edit.title": "Modifier le tag",
    "tag.form.active": "Actif",
    "tag.form.allowRobots": "Afficher dans les moteurs de recherche",
    "tag.form.asyncvalidate.reject": "Ce nom est déjà utilisé",
    "tag.form.description": "Description",
    "tag.form.geneeaEntity.hint": "Les articles marqués avec cette entité apparaissent automatiquement sur la page de ce tag. Si vous ne le souhaitez pas, retirez l’entité ci-dessus et enregistrez les modifications.",
    "tag.form.geneeaEntity.label": "Entité assignée",
    "tag.form.image": "Image",
    "tag.form.name": "Nom",
    "tag.form.title": "Titre",
    "tag.list.addButton": "Créer un tag",
    "tag.list.tab.active": "Actif",
    "tag.list.tab.all": "Tout",
    "tag.name": "Nom",
    "tag.setup.title": "Créer un tag",
    "tag.title": "Titre",
    "team.edit.title": "Editer l'équipe",
    "team.form.image": "Image",
    "team.form.image.edit": "Modifier l'image",
    "team.form.leagues": "Ligues",
    "team.form.leagues.placeholder": "Sélectionner des ligues...",
    "team.form.name": "Nom",
    "team.form.noResults": "Aucun résultat trouvé",
    "team.header.select.iceHockeyTeams": "Equipes de hockey",
    "team.header.select.leaguesAndTournaments": "Ligues et tournois",
    "team.header.select.soccerTeams": "Equipes de football",
    "team.header.select.tennisPlayers": "Joueurs de tennis",
    "team.route.iceHockeyTeams.create.label": "Créer équipe",
    "team.route.leaguesAndTournaments.create.label": "ligue ou tournoi",
    "team.route.soccerTeams.create.label": "Créer équipe",
    "team.route.tennisPlayers.create.label": "Créer joueur(s)",
    "team.setup.title": "Créer une équipe",
    "team.type.select": "Sélectionner équipes, joueurs, ligues et tournois...",
    "teaser.form.submitButton": "Ok",
    "tenantchooser.editButton": "Modifier les publications",
    "tenantchooser.mainTenant": "Site web principal",
    "tenantchooser.mainTenant.placeholder": "Sélectionner le site web principal",
    "tenantchooser.modal.title": "Websites / Apps sélectionnés",
    "tenantgroup.checkbox.bern": "Berne",
    "tenantgroup.checkbox.régionaux": "Régionaux",
    "tenantgroup.checkbox.tamediaNews": "Tamedia news",
    "tenantgroup.checkbox.zürich": "Zurich",
    "tenants.selection.submitButton": "Appliquer",
    "tenantspecific.copy.button": "Appliquer",
    "tenantSpecific.copy.label": "Copier les valeurs dans :",
    "tenantSpecific.copy.placeholder": "Sélectionner des publications",
    "tenantspecific.error": "Valeurs incorrectes trouvées",
    "tenantspecific.variantButton": "Variantes",
    "tennis.edit.title": "Modifier joueur / double",
    "tennis.form.name": "Nom du joueur / double",
    "tennis.form.radio.title.mode": "Mode",
    "tennis.setup.title": "Créer un joueur / double",
    "ticker.content.editButton": "Modifier",
    "ticker.content.editPost": "Modifier l'entrée",
    "ticker.content.newPost": "Nouvelle entrée",
    "ticker.event.athletics": "Gymnastique",
    "ticker.event.basketball": "Basketball",
    "ticker.event.beachVolleyball": "Beach-volleyball",
    "ticker.event.card": "Carton",
    "ticker.event.crossCountrySkiing": "Ski de randonnée nordique",
    "ticker.event.curling": "Curling",
    "ticker.event.cycling": "Cyclisme",
    "ticker.event.equestrianism": "Équitation",
    "ticker.event.fencing": "Escrime",
    "ticker.event.figureSkating": "Patinage artistique",
    "ticker.event.formula1": "Formule 1",
    "ticker.event.freeText": "Autre",
    "ticker.event.game": "Jeu",
    "ticker.event.gameEnd": "Fin de jeu",
    "ticker.event.gameMinute": "Minute de jeu",
    "ticker.event.gameStart": "Début de jeu",
    "ticker.event.goal": "Goal",
    "ticker.event.golf": "Golf",
    "ticker.event.halftimeEnd": "Fin de mi-temps",
    "ticker.event.halftimeStart": "Début de mi-temps",
    "ticker.event.horseRiding": "Horse riding",
    "ticker.event.iceHockey": "Hokey sur glace",
    "ticker.event.info": "Info",
    "ticker.event.match": "Match",
    "ticker.event.miss": "Raté",
    "ticker.event.overtimeEnd": "Fin de prolongation",
    "ticker.event.overtimeStart": "Début de prolongation",
    "ticker.event.penalty": "Pénalité",
    "ticker.event.periodEnd": "Fin de période",
    "ticker.event.periodStart": "Début de période",
    "ticker.event.point": "Point",
    "ticker.event.set": "Set",
    "ticker.event.shootOut": "Tirs au but",
    "ticker.event.shootOutEnd": "Fin des tirs au but",
    "ticker.event.shootOutStart": "Début des tirs au but",
    "ticker.event.skiing": "Ski",
    "ticker.event.snowboarding": "Snowboard",
    "ticker.event.soccer": "Football",
    "ticker.event.substitution": "Remplacement",
    "ticker.event.swimming": "Natation",
    "ticker.event.team1": "Equipe 1",
    "ticker.event.team2": "Equipe 2",
    "ticker.event.tennis": "Tennis",
    "ticker.event.tiebreak": "Tiebreak",
    "ticker.event.timeEvent": "Phase de jeu",
    "ticker.event.timeout": "Arrêts de jeu",
    "ticker.event.volleyball": "Volleyball",
    "ticker.eventform.compact.eventType.placeholder": "Sélectionner un sport...",
    "ticker.eventform.date": "Date",
    "ticker.eventform.dateTime": "Heure de l'événement",
    "ticker.eventform.displayTime": "Afficher l'heure",
    "ticker.eventform.error": "Définis l'entrée sur invisible ou le message doit être rempli",
    "ticker.eventform.eventType.label": "Type",
    "ticker.eventform.keyEvent": "Événement important",
    "ticker.eventform.keyEvent.title.required": "Si la case « Événement important » est cochée, le titre du entrée ne peut pas être vide.",
    "ticker.eventform.message": "Message",
    "ticker.eventform.title": "Titre",
    "ticker.eventform.visible": "Visible",
    "ticker.eventlist.teaser": "Teaser",
    "ticker.eventlist.teaserform.applyteaser": "Appliquer les modifications au teaser",
    "ticker.eventlist.teaserform.intro": "Intro",
    "ticker.eventlist.teaserform.lead": "Chapeau",
    "ticker.eventlist.teaserform.title": "Titre",
    "ticker.eventlist.teaserform.titleHeader": "Surtitre",
    "ticker.list.createButton": "Créer un Ticker",
    "ticker.list.pageTitle": "Livetickers",
    "ticker.setup.league.league": "Ligue",
    "ticker.setup.league.mode": "Mode",
    "ticker.setup.noTeamFound": "Equipe introuvable",
    "ticker.setup.pageTitle": "Nouveau liveticker",
    "ticker.setup.scoreboardEnabled": "Afficher le tableau de bord défaut",
    "ticker.setup.teamSelector.player": "Joueur",
    "ticker.setup.teamSelector.team": "Équipe",
    "ticker.setup.tickerType": "Type de liveticker",
    "ticker.soccer.card.red": "Rouge",
    "ticker.soccer.card.yellow": "Jaune",
    "ticker.soccer.redCard": "Carton rouge",
    "ticker.soccer.yellowCard": "Carton jaune",
    "ticker.tennis.break": "Break",
    "ticker.tennis.breakball": "Balle de break",
    "ticker.tennis.matchball": "Balle de match",
    "ticker.tennis.mini-break": "Mini-Break",
    "ticker.tennis.scoreboard.match.finished": "Le match est terminé",
    "ticker.tennis.scoreboard.serveFirst": "Premier à servir",
    "ticker.tennis.set": "Set",
    "ticker.tennis.setball": "Balle de set",
    "ticker.type.iceHockey": "Hockey sur glace",
    "ticker.type.soccer": "Football",
    "ticker.type.sportsCompact": "Sport compact",
    "ticker.type.standard": "Standard",
    "ticker.type.tennis": "Tennis",
    "toolbar.articleBuddy.approve": "Appliquer",
    "toolbar.articleBuddy.backButton.title": "Nouvelle évaluation",
    "toolbar.articleBuddy.category.balancedReporting.description": "Identifie les omissions ou distorsions sélectives qui faussent l'ensemble du tableau.",
    "toolbar.articleBuddy.category.balancedReporting.label": "Équilibre éditorial",
    "toolbar.articleBuddy.category.chartPotential.description": "Repère les passages qu’un graphique Datawrapper ou carte rendrait plus clairs. Pour ce faire, l’outil analyse l’article pour en extraire les données exploitables et les prépare de façon à ce que tu puisses les charger directement dans le Datawrapper Helper. Il complète les données manquantes à partir de sources publiques fiables, avec citation.",
    "toolbar.articleBuddy.category.chartPotential.label": "Potentiel graphique",
    "toolbar.articleBuddy.category.clarity.description": "Signale le jargon non expliqué, les abréviations ou le contexte manquant. Garantit l'accessibilité pour un large public.",
    "toolbar.articleBuddy.category.clarity.label": "Clarté",
    "toolbar.articleBuddy.category.contextAndAccuracy.description": "Évalue si les affirmations sont étayées par des sources et fournissent suffisamment de contexte pour la compréhension.",
    "toolbar.articleBuddy.category.contextAndAccuracy.label": "Contexte et précision",
    "toolbar.articleBuddy.category.erase.description": "Signale des passages entiers pouvant être supprimés pour raccourcir le texte sans perdre le sens essentiel.",
    "toolbar.articleBuddy.category.erase.label": "Supprimer",
    "toolbar.articleBuddy.category.fairness.description": "Vérifie que les parties concernées ont eu droit de réponse et que la présomption d'innocence est respectée.",
    "toolbar.articleBuddy.category.fairness.label": "Équité",
    "toolbar.articleBuddy.category.genderInclusiveLanguage.description": "Vérifie l'utilisation du masculin générique. Recommande des alternatives neutres tout en respectant les personnes nommément citées.",
    "toolbar.articleBuddy.category.genderInclusiveLanguage.label": "Écriture inclusive",
    "toolbar.articleBuddy.category.helvetisms.description": "Assure l'utilisation cohérente du français standard suisse. Remplace les gallicismes par les helvétismes appropriés.",
    "toolbar.articleBuddy.category.helvetisms.label": "Français de Suisse",
    "toolbar.articleBuddy.category.independence.description": "Évalue si le reportage est indépendant des influences des relations publiques.",
    "toolbar.articleBuddy.category.independence.label": "Indépendance",
    "toolbar.articleBuddy.category.languageStyle.description": "Vérifie les nominalisations, les constructions passives, les mots de remplissage, les clichés et les redondances. Privilégie les formulations actives et concises avec des verbes forts.",
    "toolbar.articleBuddy.category.languageStyle.label": "Langue & Style",
    "toolbar.articleBuddy.category.misspelledNames.description": "Relève les noms des personnes qui semblent mal orthographiés. Indique à la place l'orthographe qui semble être la bonne. Pour ce faire, l'outil compare chaque nom via une recherche web avec des sources fiables (ex. sites institutionnels ou Linkedin) en tenant compte du contexte de l'article.",
    "toolbar.articleBuddy.category.misspelledNames.label": "Noms mal orthographiés",
    "toolbar.articleBuddy.category.nonDiscrimination.description": "Vérifie que la nationalité, l'ethnicité, la religion ou l'orientation sexuelle ne sont mentionnées que si elles sont pertinentes pour l'histoire.",
    "toolbar.articleBuddy.category.nonDiscrimination.label": "Non-discrimination",
    "toolbar.articleBuddy.category.opinionVsFact.description": "Vérifie que les opinions sont clairement marquées comme telles et non présentées comme des faits.",
    "toolbar.articleBuddy.category.opinionVsFact.label": "Opinion vs fait",
    "toolbar.articleBuddy.category.paraphrase.description": "Propose des formulations plus courtes qui conservent le sens tout en réduisant le nombre de caractères.",
    "toolbar.articleBuddy.category.paraphrase.label": "Reformuler",
    "toolbar.articleBuddy.category.pluralism.description": "Évalue si différentes perspectives sont représentées, notamment sur les sujets controversés.",
    "toolbar.articleBuddy.category.pluralism.label": "Pluralisme",
    "toolbar.articleBuddy.category.privacy.description": "Évalue le traitement des informations sensibles et des détails privés.",
    "toolbar.articleBuddy.category.privacy.label": "Vie privée",
    "toolbar.articleBuddy.category.punctuation.description": "Vérifie l'utilisation correcte des deux-points, tirets et autres signes de ponctuation. Signale les usages excessifs ou incorrects.",
    "toolbar.articleBuddy.category.punctuation.label": "Ponctuation",
    "toolbar.articleBuddy.category.quotations.description": "Évalue si les citations apportent une valeur ajoutée (opinion, émotion, originalité). Signale les citations vides ou redondantes qui devraient être paraphrasées ou supprimées.",
    "toolbar.articleBuddy.category.quotations.label": "Citations",
    "toolbar.articleBuddy.category.sentenceStructure.description": "Identifie les phrases trop longues ou imbriquées. Recommande de les diviser en unités claires et lisibles.",
    "toolbar.articleBuddy.category.sentenceStructure.label": "Construction des phrases",
    "toolbar.articleBuddy.category.sourceTransparency.description": "Vérifie que les sources sont rendues transparentes et que les conflits d'intérêts potentiels sont divulgués.",
    "toolbar.articleBuddy.category.sourceTransparency.label": "Transparence des sources",
    "toolbar.articleBuddy.category.structureNarrativeArc.description": "Évalue l'accroche, la logique du texte, les transitions et la conclusion. Signale l'absence de fil conducteur ou les débuts/fins faibles.",
    "toolbar.articleBuddy.category.structureNarrativeArc.label": "Structure & Dramaturgie",
    "toolbar.articleBuddy.category.toneLanguageRegister.description": "Vérifie les familiarismes inappropriés, le langage administratif ou les formulations partisanes. Assure un ton neutre et professionnel.",
    "toolbar.articleBuddy.category.toneLanguageRegister.label": "Registre de langue",
    "toolbar.articleBuddy.categoryTeaser": "La vérification prend en compte les critères suivants. Seuls les critères indiquant un besoin d'examen complémentaire sont affichés.",
    "toolbar.articleBuddy.checklist": "Checklist",
    "toolbar.articleBuddy.dismiss": "Ignorer",
    "toolbar.articleBuddy.error": "Erreur lors du chargement des résultats, réessaie plus tard.",
    "toolbar.articleBuddy.feedback": "Tu as des retours sur l'Article Buddy? Écris tes suggestions sur Slack: <link />",
    "toolbar.articleBuddy.intro": "Sélectionne les checks souhaités et lance l'analyse. Selon la longueur du texte, cela peut prendre jusqu'à quatre minutes.",
    "toolbar.articleBuddy.modal.confirmationMessage": "L'analyse actuelle de l'Article Buddy sera supprimée, <br /> les ajustements de texte effectués seront toutefois conservés. <br /> Tu peux ensuite lancer une nouvelle analyse.",
    "toolbar.articleBuddy.modal.confirmationTitle": "Terminer l'analyse ?",
    "toolbar.articleBuddy.noResults": "Aucune suggestion.",
    "toolbar.articleBuddy.reviewCriteriaModal.closeButton.title": "Fermer",
    "toolbar.articleBuddy.reviewCriteriaModal.title": "Critères de révision",
    "toolbar.articleBuddy.submitButton": "Évaluer mon article",
    "toolbar.articleBuddy.submitButton.tooltip": "Des modifications non enregistrées ou un contenu vide sont présents. Enregistre l'article avant vérification.",
    "toolbar.articleBuddy.summary": "Résumé",
    "toolbar.articleBuddy.title": "Article Buddy",
    "toolbar.articleBuddy.types.graphic.description": "Identifier les passages qu’un graphique ou carte viendrait éclairer.",
    "toolbar.articleBuddy.types.graphic.label": "Vérification graphique",
    "toolbar.articleBuddy.types.nameChecker.description": "Vérifier par recherche web l'orthographe des noms de personnes dans l'article.",
    "toolbar.articleBuddy.types.nameChecker.label": "Vérification de noms",
    "toolbar.articleBuddy.types.shortening.description": "Réduction intelligente du nombre de caractères de l'article selon la longueur cible.",
    "toolbar.articleBuddy.types.shortening.label": "Suggestions de raccourcissement",
    "toolbar.articleBuddy.types.shortening.tooltip": "Les suggestions de raccourcissement nécessitent une longueur de texte définie. Si le champ «Nombre de caractères cible» dans l'onglet «Métadonnées» est vide ou réglé sur «Special Length», aucune suggestion n'est possible.",
    "toolbar.articleBuddy.types.standards.description": "Vérifier l'article par rapport aux normes et directives éditoriales.",
    "toolbar.articleBuddy.types.standards.label": "Standards",
    "toolbar.articleBuddy.types.style.description": "Vérifier la langue, la lisibilité, la structure et le ton de l'article.",
    "toolbar.articleBuddy.types.style.label": "Style",
    "toolbar.attachments.copyImageUrl": "Copier l'URL de l'image",
    "toolbar.attachments.delete.modal.message": "Ce fichier doit-il vraiment être supprimé des documents attachés ?",
    "toolbar.attachments.delete.modal.title": "Supprimer des documents attachés",
    "toolbar.attachments.deleteImage": "Supprimer l'image",
    "toolbar.attachments.mode.cards": "Afficher sous forme de cartes",
    "toolbar.attachments.mode.list": "Afficher sous forme de liste",
    "toolbar.attachments.status.unused": "Pas utilisé online",
    "toolbar.attachments.status.used": "Utilisé online",
    "toolbar.attachments.title": "Documents attachés",
    "toolbar.attachments.zoomImage": "Agrandir l'image",
    "toolbar.comments.commentsInText": "... commentaires dans ce texte",
    "toolbar.comments.description1": "Des commentaires peuvent être ajoutés en mettant en surbrillance un passage de texte, puis en soumettant un champ de texte qui sera affiché.",
    "toolbar.comments.description2": "Les commentaires peuvent être activées ou désactivées avec la combinaison de touches <kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>K</kbd> ou en ouvrant et fermant la fenêtre.",
    "toolbar.comments.title": "Commentaires",
    "toolbar.liquidContent.addFormat": "Ajouter un format",
    "toolbar.liquidContent.articleFormat": "Format d'article",
    "toolbar.liquidContent.articleFormats": "Format d'articles",
    "toolbar.liquidContent.create": "Créer des variantes liquides",
    "toolbar.liquidContent.create.button": "Créer",
    "toolbar.liquidContent.create.description": "Sélectionne les formats et les publications ci-dessous. En cliquant sur le bouton vert, les articles supplémentaires seront créés et leur contenu sera réécrit par l'IA, selon tes préférences.",
    "toolbar.liquidContent.error": "Une erreur s'est produite lors de la génération des variantes liquides. Réessaie.",
    "toolbar.liquidContent.format": "Format",
    "toolbar.liquidContent.format.none": "Aucune",
    "toolbar.liquidContent.format.qa": "Q&A",
    "toolbar.liquidContent.format.short": "Paraphrase",
    "toolbar.liquidContent.format.source": "Article source",
    "toolbar.liquidContent.tenants": "Publications",
    "toolbar.liquidContent.title": "Content liquide",
    "toolbar.liquidContent.tooltip": "Un autre utilisateur a déjà commencé à créer des variantes liquides. Une fois prêtes, tu les verras dans cet onglet.",
    "toolbar.otherAiTools.description": "Les outils ci-dessous sont déjà intégrés à Tamedia Toolbox, mais pas encore à Unity. Un clic sur le lien ouvre la Toolbox dans un nouvel onglet et lance la génération. Important: Les outils sont peut-être encore en phase de test.",
    "toolbar.otherAiTools.title": "Autres outils IA",
    "toolbar.otherAiTools.toolNames.datawrapperHelper": "Vers le Datawrapper Helper",
    "toolbar.otherAiTools.toolNames.printTeaser": "Générer une accroche print",
    "toolbar.otherAiTools.toolNames.pushMessage": "Générer un push",
    "toolbar.otherAiTools.toolNames.translation": "Traduire l'article",
    "toolbar.revisions.by": "par",
    "toolbar.revisions.created": "Créé",
    "toolbar.revisions.restore": "Restaurer",
    "toolbar.revisions.revision": "Révision",
    "toolbar.revisions.title": "Révisions",
    "toolbar.seoChecker.error": "Une erreur est survenue",
    "toolbar.seoChecker.googleTrendsSuggestions": "Suggestions sur Google Trends",
    "toolbar.seoChecker.grade.bad": "Insuffisant",
    "toolbar.seoChecker.grade.fantastic": "Fantastique",
    "toolbar.seoChecker.grade.good": "Bon",
    "toolbar.seoChecker.grade.okay": "Satisfaisant",
    "toolbar.seoChecker.grade.veryGood": "Très bon",
    "toolbar.seoChecker.header": "Évaluation SEO",
    "toolbar.seoChecker.keywords": "Les cinq mots-clés principaux de ce texte sont:",
    "toolbar.seoChecker.keywordsMissing.shortArticle": "Le contrôle SEO ne peut pas être effectué sans mots-clés. Ceux-ci sont générés automatiquement lorsque le texte de l'article est inférieur de 150 à sa longueur cible. Si ce n’est pas le cas, les mots-clés peuvent être générés manuellement dans l'encadré SEO teaser dans les métadonnées de l'article. Il te suffit alors de cliquer sur le bouton «Générer des mots-clés».",
    "toolbar.seoChecker.keywordsMissing.specialLength": "La Special Length étant définie comme cible pour cet article, les mots-clés ne sont pas générés automatiquement. our effectuer le contrôle SEO, les mots-clés peuvent être générés manuellement dans l'encadré SEO teaser dans les métadonnées de l'article. Il te suffit alors de cliquer sur le bouton «Générer des mots-clés».",
    "toolbar.seoChecker.keywordsMissing.title": "Mots clés manquants, génère-les.",
    "toolbar.seoChecker.title": "SEO Helper",
    "toolbar.spellChecker.congratulations": "Félicitations!",
    "toolbar.spellChecker.description1": "Elles sont soulignées en <red>rouge</red> (orthographe), <green>vert</green> (grammaire), <blue>bleu</blue> (typographie) ou <orange>orange</orange> (autre) dans l'éditeur.",
    "toolbar.spellChecker.description2": "Elles peuvent être corrigées en cliquant sur les mots soulignés dans l'éditeur et en sélectionnant une alternative ou en tapant simplement les corrections nécessaires.",
    "toolbar.spellChecker.description3": "La correction orthographique peut être activée ou désactivée avec la combinaison des touches <pre>Ctrl + Shift + A</pre> ou en fermant la fenêtre.",
    "toolbar.spellChecker.error": "Une erreur est survenue",
    "toolbar.spellChecker.errorsReported": "... erreurs signalées pour ce texte",
    "toolbar.spellChecker.evaluatingText": "Le texte est en cours de vérification",
    "toolbar.spellChecker.noErrors": "Il n'y a pas d'erreurs dans ce contenu",
    "toolbar.spellChecker.title": "Correcteur d'orthographe",
    "toolbar.spellChecker.wait": "Attendez, s.v.p.",
    "toolbar.teaserGenerator.apply": "Adopter la suggestion",
    "toolbar.teaserGenerator.error": "Une erreur est survenue",
    "toolbar.teaserGenerator.error.unknown": "Une erreur inconnue est survenue.",
    "toolbar.teaserGenerator.fewerProposals": "Il n'a pas été possible de générer les {{numOfProposals}} propositions",
    "toolbar.teaserGenerator.intro": "Génère des suggestions pour trois teasers différents basés sur le texte actuel de l'article. Convient uniquement pour les annonces d'agences ou de municipalités.",
    "toolbar.teaserGenerator.introBold": "La suggestion doit impérativement être vérifiée en termes de contenu et de style. Pour toute question, adresse-toi à #ai_lab_infos",
    "toolbar.teaserGenerator.proposal": "Teaser proposé",
    "toolbar.teaserGenerator.propose": "Proposer des teasers",
    "toolbar.teaserGenerator.proposeButton.tooltip": "Les suggestions de teaser ne peuvent pas être générées pour un article vide.",
    "toolbar.teaserGenerator.refresh": "Regénérer les suggestions",
    "toolbar.teaserGenerator.retry": "Réessayer",
    "toolbar.teaserGenerator.title": "Suggestions de Teaser",
    "toolbar.teaserGenerator.wait": "Un instant",
    "toolbar.teaserGenerator.waitDescription": "Les teasers sont en cours de génération.",
    "toolbar.translation.directionToFrench": "Allemand → Français",
    "toolbar.translation.directionToGerman": "Français → Allemand",
    "toolbar.translation.emptyArticle": "L'article ne contient pas de texte à traduire.",
    "toolbar.translation.failed": "La traduction a échoué.",
    "toolbar.translation.introToFrench": "La traduction est créée comme nouvel article dans la version française.",
    "toolbar.translation.introToGerman": "La traduction est créée comme nouvel article dans la version allemande.",
    "toolbar.translation.openArticle": "Ouvrir l'article",
    "toolbar.translation.pendingHint": "Cela peut prendre quelques minutes. Tu peux continuer à travailler – le résultat s'affichera ici.",
    "toolbar.translation.pendingIntoFrench": "Traduction vers le français…",
    "toolbar.translation.pendingIntoGerman": "Traduction vers l'allemand…",
    "toolbar.translation.submit": "Traduire",
    "toolbar.translation.success": "L'article a été traduit.",
    "toolbar.translation.title": "Traduction",
    "toolbar.translation.translateAgain": "Traduire à nouveau",
    "toolbar.translation.tryAgain": "Réessayer",
    "toolbar.translation.unsavedChanges": "La traduction utilise la dernière version enregistrée – enregistre d'abord tes modifications.",
    "toolbar.userNeeds.depth": "Mise en contexte",
    "toolbar.userNeeds.depth.description": "Donne-moi de l’analyse et des explications",
    "toolbar.userNeeds.distract": "Divertissement",
    "toolbar.userNeeds.distract.description": "Distraits-moi",
    "toolbar.userNeeds.facts": "Faits",
    "toolbar.userNeeds.facts.description": "Donne-moi l'essentiel",
    "toolbar.userNeeds.inspiration": "Émotion",
    "toolbar.userNeeds.inspiration.description": "Touche-moi ou inspire-moi",
    "toolbar.userNeeds.justification": "Justification",
    "toolbar.userNeeds.none.description": "L’analyse des User Needs pour cet article est en attente. L’analyse démarre automatiquement lorsque le texte de l'article est inférieur de 150 à sa longueur cible. Tu peux l’activer manuellement en appuyant sur le bouton ci-dessous.",
    "toolbar.userNeeds.none.name": "Aucun",
    "toolbar.userNeeds.none.targetDescription": "Aucun User Need prévu. Tu peux définir un User Need sur la page de publication sous Planification.",
    "toolbar.userNeeds.service": "Service",
    "toolbar.userNeeds.service.description": "Donne-moi des conseils et des instructions",
    "toolbar.userNeeds.startAnalysis": "Commencer l’analyse",
    "toolbar.userNeeds.startAnalysis.disabled.blankOrDirty.tooltip": "L'analyse ne peut pas être démarrée avant que l'article ne soit enregistré ou si son contenu est vide.",
    "toolbar.userNeeds.startAnalysis.disabled.otherUserGenerating.tooltip": "Un autre utilisateur a déjà commencé l'analyse des User Needs. Une fois prêt, tu le verras dans cet onglet.",
    "toolbar.userNeeds.startAnalysis.tooltip": "Chaque article doit être rédigé en se concentrant clairement sur un user need, afin de répondre au mieux aux besoins des lecteurs. <spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1wooB_7-Zvyh2DvEf9oPcVZeF97pdCfXFyFr1huhKjeg/edit?usp=sharing'>Modèle Tamedia User Needs</linkComponent",
    "toolbar.userNeeds.title": "User need",
    "toolbar.userNeeds.title.description": "Basé sur une analyse de contenu:",
    "toolbar.userNeeds.title.targetDescription": "Prévu:",
    "user.firstName": "Prénom",
    "user.fullName": "Nom complet",
    "user.id": "User-ID",
    "user.jobTitle": "Titre du poste",
    "user.lastName": "Nom",
    "user.list.addButton": "Créer un compte externe",
    "user.list.tab.all": "Tous",
    "user.list.tab.external": "Externes",
    "user.list.tab.internal": "Internes",
    "user.longBiography": "Biographie longue",
    "user.prolitterisId": "Prolitteris-ID",
    "user.shortBiography": "Biographie courte",
    "user.shortName": "Nom court",
    "user.twitterHash": "Nom d'utilisateur X",
    "user.userImage": "Image de profil",
    "userForm.editButton": "Modifier",
    "userForm.oktaAccount": "Compte Okta",
    "userForm.title.create": "Créer un profil",
    "userForm.title.edit": "Profil",
    "userForm.title.tooltip": "La biographie courte est affichée sous les articles, elle a une longueur maximale de 180 caractères. La biographie longue est affichée sur la page de l'auteur (pas de longueur maximale). Les biographies doivent commencer par le nom en gras : Nom de famille Nom [...Texte...]. L'image doit être carrée (idéalement : 350x350 pixels). <spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1ZYaMhM8azwBqO0CgV0NqJe9ttiy1Gx1fF-Cs6dRZl04/edit#heading=h.cevy7glcj2ve'>Le guide praticque.</linkComponent>",
    "users.list.title": "Comptes",
    "userSettings.betaFeaturesEnabled.label": "Utiliser les fonctions bêta",
    "userSettings.language.deCh": "Deutsch",
    "userSettings.language.enGb": "English",
    "userSettings.language.frCh": "Français",
    "userSettings.title": "Préférences",
    "userSettings.uiLocale": "Langage de l'interface utilisateur",
    "userSettings.uiLocaleDescription": "Cette option affecte les textes de l'interface utilisateur tels que les labels et les boutons.",
    "validate.team.teamsCollision": "Choisis deux équipes différentes, s'il te plaît",
    "validator.message.date": "Date invalide fournie",
    "validator.message.deepLink": "Entre une URL valide.",
    "validator.message.hexadecimalColor": "Code couleur hexadécimal obligatoire  (e.g. #DDEE55)",
    "validator.message.insecureUrl": "Entre une URL valide.",
    "validator.message.invalidEmbedCode": "Code d'intégration invalide",
    "validator.message.invalidFrontendComponentUrl": "URL invalide. Elle doit contenir \"tagesanzeiger.ch\"",
    "validator.message.invalidJson": "JSON invalide",
    "validator.message.invalidJsonObject": "Le JSON doit être un objet",
    "validator.message.invalidProlitterisId": "Peut être d'au maximum {{maxLength}} chiffres",
    "validator.message.invalidTimeFormat": "Temps invalide fournie",
    "validator.message.invalidTwitteUsername": "Caractères autorisés: \"a-z\", \"0-9\", \"_\" et au maximum 15 caractères",
    "validator.message.isNotFutureDate": "La date doit être dans le futur",
    "validator.message.isPastDate": "La date ne peut pas être dans le passé",
    "validator.message.isPastTime": "La temps ne peut pas être dans le passé",
    "validator.message.livestreamVideoCmsError": "Code d'intégration du livestream videoCms invalide",
    "validator.message.maxLength": "Doit être d'au maximum {{maxLength}} lettres ou symboles de long",
    "validator.message.minLength": "Doit être d'au moins {{minLength}} lettres ou symboles de long",
    "validator.message.noInternalUrl": "Les URLs internes ne sont pas autorisées",
    "validator.message.numbersOnly": "Ne doit contenir que des chiffres",
    "validator.message.oneIframeOrUrl": "Entre une URL valide et sécurisée (https) ou une iframe correctement formatée (<iframe></iframe> avec https).",
    "validator.message.oneIframeUrlOrEmbedCode": "Entre une URL valide et sécurisée (https), une iframe correctement formatée (<iframe></iframe> avec https) ou un code d’intégration pris en charge (Glomex, JW Player, etc.).",
    "validator.message.path": "Le chemin ne peut pas contenir de symboles tels que :",
    "validator.message.required": "Requis",
    "validator.message.secureUrl": "Entre une URL valide et sécurisée (https).",
    "validator.message.secureUrlOrMailto": "Entre une URL valide et sécurisée (https), ou un lien 'mailto:'.",
    "validator.message.startWithSlash": "Le chemin doit commencer par /",
    "validator.message.validUrlOrEmbedCode": "Entre une URL valide, ou un code d'intégration.",
    "validator.message.validUrlOrMailto": "Entre une URL valide, ou un lien 'mailto:'.",
    "validator.message.videoCmsError": "Code d'intégration du videoCms invalide",
    "validator.message.videoCmsVideoIdError": "Id vidéo manquant dans le code d'intégration",
    "validator.message.weightRange": "Doit être compris entre 0 et 1",
    "validator.notificationCategories.atLeastOneCategoryPerTenant": "Merci de sélectionner au moins une catégorie pour {{ tenantNames }}",
    "validators.urlSlug.allowedChars": "Caractères autorisés: \"a-z\", \"0-9\" and \"-\"",
    "validators.urlSlug.alreadyTaken": "Ce chemin est déjà utilisé.",
    "variants.selection.edit": "Modifier les variantes",
    "versionUsed": "Version de l'interface Unity utilisée: {{version}}",
    "video.form.intro": "Intro",
    "video.form.lead": "Chapeau",
    "video.form.title": "Titre",
    "video.form.titleHeader": "Surtitre",
    "video.form.video": "Vidéo",
    "video.setup.pageTitle": "Nouvelle vidéo",
    "videoUpload.error.noPreviewImage": "Merci d'attendre que l'image d'aperçu de la vidéo soit téléchargée",
    "workflowChecklist": "Checklist",
    "workflowChecklist.noChanges": "Aucun changement jusqu'à présent pour cette tâche",
    "workflowChecklist.photoeditingDone": "Rédaction photos",
    "workflowChecklist.productionDone": "Edition",
    "workflowChecklist.proofreadingDone": "Correction",
    "workflowChecklist.seoDone": "SEO",
    "workflowChecklist.spellcheckingDone": "Correcteur d'orthographe",
    "workflowChecklist.spellcheckingDone.disabled": "Ouvre le correcteur d'orthographe pour mettre à jour cette case à cocher."
}
